import PUBLIC_CONTENT from '../data/public-content.json';
import React from 'react';
import { createRoot } from 'react-dom/client';
const ReactDOM = { createRoot };
window.React = React;
window.ReactDOM = ReactDOM;


/* src/data.js */
/* Static content — what would live in WordPress posts */

const ARTICLES = [
  {
    slug: 'canon-a1-fuite-courant',
    title: "Canon A1 – Fuite de courant qui vide la pile",
    category: 'Boitier',
    tag: 'canon a1',
    date: '23 mars 2022',
    readTime: '6 min',
    excerpt: "Une panne classique sur ce modèle populaire. Après plusieurs décennies de service, il est courant que l'appareil vide la pile trop rapidement. Un simple nettoyage du sandwich de contact du bouton de test batterie règle le problème dans la majorité des cas.",
    cover: 'canon a1 — chassis ouvert',
    featured: true,
  },
  {
    slug: 'yashica-mat-124g-revision',
    title: "Révision d'un Yashica MAT 124 G",
    category: 'Boitier',
    tag: 'yashica',
    date: '1 mars 2022',
    readTime: '12 min',
    excerpt: "Mécanique de l'armement bloquée, cellule capricieuse. Démontage complet d'un TLR moyen format emblématique.",
    cover: 'yashica mat 124g — détail mécanisme',
  },
  {
    slug: 'pentax-s1a-miroir',
    title: 'Pentax S1a – Miroir qui reste en position haute',
    category: 'Boitier',
    tag: 'pentax',
    date: '14 oct. 2021',
    readTime: '8 min',
    excerpt: "Symptôme fréquent sur les reflex 35mm anciens. On passe en revue les causes possibles avant d'ouvrir le boitier.",
    cover: 'pentax s1a — viseur démonté',
  },
  {
    slug: 'canon-a1-cabestan',
    title: "Remplacement du cabestan d'un Canon A1",
    category: 'Boitier',
    tag: 'canon a1',
    date: '22 mai 2021',
    readTime: '15 min',
    excerpt: "Opération chirurgicale pour remplacer cette petite pièce essentielle à l'entraînement de la pellicule.",
    cover: 'cabestan canon a1 — pièces détachées',
  },
  {
    slug: 'canon-a1-pause-b',
    title: "Un Canon A1 bloqué sur pause B",
    category: 'Boitier',
    tag: 'canon a1',
    date: '3 déc. 2020',
    readTime: '5 min',
    excerpt: "Un classique : l'obturateur reste ouvert en pose B. Cause fréquente et solution rapide.",
    cover: 'canon a1 — molette vitesses',
  },
  {
    slug: 'takumar-55-diaph',
    title: 'Réglage de diaphragme sur un Asahi Super-Takumar 55mm f/2',
    category: 'Objectif',
    tag: 'takumar',
    date: '25 juil. 2022',
    readTime: '7 min',
    excerpt: "Avec le temps et les vibrations, la bague de réglage du diaphragme peut bouger et fausser l'ouverture. Intervention simple.",
    cover: 'super-takumar 55mm — vue de face',
    featured: true,
  },
  {
    slug: 'olympus-zuiko-200-champi',
    title: "Nettoyage d'un Olympus OM E-Zuiko AUTO-T 200mm f/4 plein de champignons",
    category: 'Objectif',
    tag: 'olympus',
    date: '9 déc. 2021',
    readTime: '14 min',
    excerpt: "Les champignons s'attaquent aux lentilles dans les environnements humides. Démontage et nettoyage pas à pas.",
    cover: 'zuiko 200mm — lentille avec champignons',
  },
  {
    slug: 'mamiya-sekor-300-champi',
    title: 'Un Mamiya Sekor C 300mm f/5.6 rempli de champignons',
    category: 'Objectif',
    tag: 'mamiya',
    date: '18 nov. 2021',
    readTime: '10 min',
    excerpt: "Moyen format, gros objectif, et une belle colonie de champignons à déloger. Patience requise.",
    cover: 'mamiya sekor 300mm — démontage',
  },
  {
    slug: 'canon-fd-55-12-champi',
    title: 'Nettoyage de champignons sur Canon FD 55mm f/1.2 SSC',
    category: 'Objectif',
    tag: 'canon fd',
    date: '5 nov. 2021',
    readTime: '11 min',
    excerpt: "Un des objectifs les plus lumineux de la gamme FD mérite bien quelques heures de soin.",
    cover: 'canon fd 55mm f/1.2 — éclaté',
  },
  {
    slug: 'olympus-zuiko-50-18',
    title: "Nettoyage d'un Olympus OM Zuiko 50mm f/1.8",
    category: 'Objectif',
    tag: 'olympus',
    date: '12 oct. 2021',
    readTime: '8 min',
    excerpt: "Le 'nifty fifty' d'Olympus, simple et efficace. Un nettoyage intérieur et il repart pour 20 ans.",
    cover: 'zuiko 50mm — monture',
  },
];

const CATEGORIES = [
  { slug: 'boitier', label: 'Boitiers', count: 42, desc: 'Reflex 35mm, TLR moyen format, télémétriques.' },
  { slug: 'objectif', label: 'Objectifs', count: 38, desc: 'Démontage, nettoyage, remontage.' },
  { slug: 'obturateur', label: 'Obturateurs', count: 14, desc: 'Central ou focal, à rideaux, lent.' },
  { slug: 'cellule', label: 'Cellules', count: 9, desc: 'CdS, Sélénium, réglage d\'exposition.' },
  { slug: 'diy', label: 'DIY', count: 7, desc: 'Outils maison, bricolage d\'atelier.' },
  { slug: 'logiciel', label: 'Logiciel', count: 5, desc: 'Scan, développement, archivage.' },
];

const PRODUCTS = [
  {
    slug: 'rolleiflex-28f-revise',
    name: 'Rolleiflex 2.8 F révisé',
    price: 1850.0,
    category: 'Appareils',
    badge: 'Révisé',
    desc: "Boîtier moyen format contrôlé en atelier, vitesses vérifiées, optiques inspectées et fonctionnement garanti.",
  },
  {
    slug: 'leitz-elmar-50mm',
    name: 'Leitz Elmar 50mm f/3.5',
    price: 390.0,
    category: 'Objectifs',
    badge: 'Occasion certifiée',
    desc: "Objectif argentique nettoyé et contrôlé : lentilles, diaphragme, rampe de mise au point et monture.",
  },
  {
    slug: 'outil-lubrif-canon-a1',
    name: 'Outil de lubrification — Canon A1 / AE1',
    price: 18.0,
    category: 'Outils',
    badge: 'Fait maison',
    desc: "Aiguille calibrée pour atteindre le fameux \"squeak\" du Canon A1, AE1 et AE1 Program sans démonter le boitier.",
  },
  {
    slug: 'phot-argus-92',
    name: 'Phot Argus n°92',
    price: 10.0,
    category: 'Livre',
    badge: 'Occasion',
    desc: "Magazine Phot Argus numéro 92. État correct, intérieur propre.",
  },
  {
    slug: 'phot-argus-93',
    name: 'Phot Argus n°93',
    price: 10.0,
    category: 'Livre',
    badge: 'Occasion',
    desc: "Numéro de collection, bon état général.",
  },
  {
    slug: 'phot-argus-62',
    name: 'Phot Argus n°62',
    price: 10.0,
    category: 'Livre',
    badge: 'Occasion',
    desc: "Un des plus anciens numéros disponibles à la boutique.",
  },
  {
    slug: 'kit-joint-canon-f1',
    name: 'Kit de joints mousse — Canon F-1',
    price: 24.0,
    category: 'Pièces',
    badge: 'Sur commande',
    desc: "Jeu complet de joints d'étanchéité pour le remplacement des mousses d'isolation.",
  },
  {
    slug: 'cle-ergot',
    name: 'Clé à ergots réglable',
    price: 32.0,
    category: 'Outils',
    badge: 'Essentiel',
    desc: "Indispensable pour ouvrir les bagues de la plupart des objectifs argentiques.",
  },
  {
    slug: 'manuel-reparation-a1',
    name: 'Manuel de réparation Canon A1 (PDF)',
    price: 8.0,
    category: 'Numérique',
    badge: 'Téléchargement',
    desc: "Service manual complet en français, 124 pages, schémas haute résolution.",
  },
  {
    slug: 'tournevis-jis',
    name: 'Jeu de tournevis JIS',
    price: 45.0,
    category: 'Outils',
    badge: 'Essentiel',
    desc: "Pointes JIS (Japanese Industrial Standard) pour ne plus massacrer les vis de vos boitiers japonais.",
  },
];

const DEVIS_STEPS = [
  {
    id: 'materiel',
    title: 'Votre matériel',
    question: "De quel matériel s'agit-il ?",
    hint: 'Plusieurs choix possibles.',
    multi: true,
    options: ['Boitier reflex 35mm', 'TLR / bi-objectif moyen format', 'Télémétrique', 'Objectif', 'Obturateur central', 'Autre'],
  },
  {
    id: 'marque',
    title: 'Marque(s) & modèle(s)',
    question: 'Pouvez-vous préciser la ou les marques et le ou les modèles ?',
    type: 'text',
    placeholder: 'ex. Canon A1, Yashica Mat 124G…',
  },
  {
    id: 'symptome',
    title: 'Symptômes',
    question: 'Décrivez les symptômes observés',
    type: 'textarea',
    placeholder: 'Obturateur bloqué, cellule qui affiche des valeurs bizarres, bruit anormal, miroir qui reste en position haute…',
  },
  {
    id: 'traitement_privilegie',
    title: 'Traitement privilégié',
    question: "Souhaitez-vous demander une option de traitement privilégié ?",
    hint: "Cette option ne garantit pas un devis immédiat : elle permet de signaler une demande prioritaire si la file d'attente atelier le permet.",
    options: ["Non, traitement standard", "Oui, je souhaite l'option de traitement privilégié"],
  },
  {
    id: 'contact',
    title: 'Vos coordonnées',
    question: "Pour que je puisse vous recontacter avec un devis",
    type: 'contact',
  },
];

Object.assign(window, { ARTICLES, CATEGORIES, PRODUCTS, DEVIS_STEPS });



/* src/i18n.js */
﻿const HOSTOPHOTO_LANGS = {
  fr: {
    code: 'fr',
    label: 'Français',
    short: 'FR',
    prefix: '',
    locale: 'fr-FR',
  },
  en: {
    code: 'en',
    label: 'English',
    short: 'EN',
    prefix: '/en',
    locale: 'en-US',
  },
};

const HOSTOPHOTO_ROUTE_SLUGS = {
  fr: {
    home: '',
    services: 'services',
    devis: 'devis',
    faq: 'faq',
    blog: 'blog',
    contact: 'contact',
    compte: 'compte',
    article: 'article',
    boutique: 'boutique',
    panier: 'panier',
  },
  en: {
    home: '',
    services: 'services',
    devis: 'quote',
    faq: 'faq',
    blog: 'blog',
    contact: 'contact',
    compte: 'account',
    article: 'article',
    boutique: 'boutique',
    panier: 'panier',
  },
};

const HOSTOPHOTO_UI = {
  fr: {
    nav: {
      services: 'Services',
      faq: 'FAQ',
      blog: 'Blog',
      boutique: 'Boutique',
      devis: 'Demande de devis',
      contact: 'Contact',
      account: 'Mon compte',
      cart: 'Panier',
    },
    topbar: {
      baseline: 'atelier@hostophoto.fr - Atelier entre Marseille et Aix-en-Provence',
      instagram: 'Instagram',
    },
    footer: {
      tagline: <>Entretien, réparation, sauvetages<br/>et petits miracles pour votre<br/>matériel photo argentique.</>,
      services: 'Services',
      interventions: 'Interventions',
      faq: 'FAQ atelier',
      quote: 'Demande de devis',
      address: 'Atelier & adresse',
      resources: 'Ressources',
      articles: 'Tous les articles',
      cameraTutorials: 'Tutoriels boîtiers',
      lensTutorials: 'Tutoriels objectifs',
      diy: 'DIY & logiciel',
      workshop: 'Atelier',
      workshopText: <>Atelier sur rendez-vous entre Marseille et Aix-en-Provence.<br/>Réponse aux demandes de devis sous 48h ouvrées.</>,
      request: 'Déposer une demande de devis',
      tracking: 'Accéder au suivi atelier',
      copyright: '© HostoPhoto 2026 · Tous droits réservés',
      claim: 'Atelier de réparation et boutique argentique',
    },
    language: {
      aria: 'Changer de langue',
    },
  },
  en: {
    nav: {
      services: 'Services',
      faq: 'FAQ',
      blog: 'Blog',
      boutique: 'Shop',
      devis: 'Request a quote',
      contact: 'Contact',
      account: 'My account',
      cart: 'Cart',
    },
    topbar: {
      baseline: 'atelier@hostophoto.fr - Film camera workshop near Marseille and Aix-en-Provence',
      instagram: 'Instagram',
    },
    footer: {
      tagline: <>Maintenance, repair, rescues<br/>and small miracles for your<br/>film photography gear.</>,
      services: 'Services',
      interventions: 'Repairs',
      faq: 'Workshop FAQ',
      quote: 'Request a quote',
      address: 'Workshop & address',
      resources: 'Resources',
      articles: 'All articles',
      cameraTutorials: 'Camera tutorials',
      lensTutorials: 'Lens tutorials',
      diy: 'DIY & software',
      workshop: 'Workshop',
      workshopText: <>Workshop by appointment near Marseille and Aix-en-Provence.<br/>Quote requests are usually answered within 48 business hours.</>,
      request: 'Submit a quote request',
      tracking: 'Open repair tracking',
      copyright: '© HostoPhoto 2026 · All rights reserved',
      claim: 'Film camera repair workshop and shop',
    },
    language: {
      aria: 'Change language',
    },
  },
};

const HOSTOPHOTO_TEXT_EN = {
  'Parlons de votre matériel.': 'Tell me about your equipment.',
  'Parlons de votre': 'Tell me about your',
  'matériel': 'equipment',
  'DEMANDE DE PRISE EN CHARGE · GRATUIT · RÉPONSE SOUS 48H': 'REPAIR INTAKE REQUEST · FREE · REPLY WITHIN 48H',
  'Démarrons par votre demande.': 'Let’s start with your request.',
  'ÉTAPE 01 · LE FORMULAIRE': 'STEP 01 · THE FORM',
  'Demande de devis': 'Quote request',
  'Vous remplissez le formulaire': 'Fill in the form',
  "Vous décrivez le matériel à envoyer et le problème observé. Plus c'est précis, plus la première réponse est utile. Si des photos sont nécessaires, elles vous seront demandées ensuite par email.": 'Describe the equipment and the issue you noticed. The more precise you are, the more useful the first reply will be. If photos are needed, I will ask for them later by email.',
  'Réponse à la demande': 'Initial reply',
  'Acceptation ou refus sous 48h': 'Accepted or refused within 48 hours',
  "Je vous réponds sous 48h pour accepter ou refuser la prise en charge. Si la demande est acceptée, vous recevez l'adresse d'envoi avec quelques conseils d'emballage.": 'I reply within 48 hours to accept or refuse the repair intake. If accepted, you receive the shipping address and packing advice.',
  "Réception à l'atelier": 'Arrival at the workshop',
  'Votre colis arrive chez moi': 'Your parcel arrives here',
  "Vous êtes notifié de la réception de votre matériel à l'atelier. Le matériel entre ensuite dans la file d'attente avant diagnostic ; en période chargée, ce délai peut atteindre plusieurs semaines.": 'You are notified when the equipment arrives at the workshop. It then enters the waiting queue before diagnosis; during busy periods this can take several weeks.',
  'Diagnostic & devis': 'Diagnosis & quote',
  'Inspection quand son tour arrive': 'Inspection when its turn comes',
  "Dès que votre matériel passe en diagnostic, vous recevez un devis chiffré par email ou dans votre espace client. Vous l'acceptez ou le refusez — sans frais en cas de refus.": 'Once your equipment is diagnosed, you receive a priced quote by email or in your customer account. You can accept or decline it, with no charge if you decline.',
  'Réparation & retour': 'Repair & return',
  'Paiement, et il rentre': 'Payment, then return shipping',
  "Une fois la réparation effectuée, vous recevez une confirmation et un lien de paiement. Vous confirmez l'adresse de retour, et votre matériel vous revient en bonne santé.": 'Once the repair is complete, you receive a confirmation and a payment link. You confirm the return address, and your equipment comes back ready to use.',
  'Comment se déroule la prise en charge de votre matériel.': 'How your equipment is handled, step by step.',
  "Cinq étapes, du formulaire jusqu'au retour de votre boitier réparé. Chaque transition vous est notifiée par email — ou dans votre espace client si vous en avez un.": 'Five steps, from the form to the return of your repaired camera. Every transition is notified by email, or in your customer account if you have one.',
  'VOUS AVEZ DÉJÀ UN COMPTE ?': 'ALREADY HAVE AN ACCOUNT?',
  'Connectez-vous à votre espace client.': 'Sign in to your customer area.',
  "Suivez l'avancement de vos demandes en cours, retrouvez vos devis, factures et l'historique de vos interventions.": 'Track current requests, quotes, invoices and your repair history.',
  'Se connecter': 'Sign in',
  'Demande reçue.': 'Request received.',
  "Retour à l'accueil": 'Back to home',
  'Nom complet': 'Full name',
  'Adresse email': 'Email address',
  'Téléphone': 'Phone',
  'facultatif': 'optional',
  'Adresse email invalide.': 'Invalid email address.',
  "J'accepte d'être recontacté au sujet de ma demande. Aucune donnée n'est transmise à des tiers.": 'I agree to be contacted about my request. No data is shared with third parties.',
  'Précédent': 'Previous',
  'Continuer': 'Continue',
  'Envoyer la demande': 'Send request',
  'Envoi en cours...': 'Sending...',
  'Gratuit': 'Free',
  'Le devis ne vous engage à rien.': 'The quote does not commit you to anything.',
  'Sous 48h': 'Within 48h',
  "Réponse sur l'acceptation ou le refus de prise en charge.": 'Reply on whether the intake is accepted or refused.',
  'Honnête': 'Honest',
  "Si c'est irréparable, vous le saurez.": 'If it cannot be repaired, you will know.',
  'Questions fr?quentes': 'Frequently asked questions',
  'FAQ ? ATELIER ? DEVIS SUR DEMANDE': 'FAQ ? WORKSHOP ? QUOTES ON REQUEST',
  'fr?quentes': 'questions',
  "Fonctionnement de l'atelier, délais, devis, envoi du matériel et garantie. Les prix restent indicatifs : chaque devis est calculé sur mesure après diagnostic.": 'Workshop process, delays, quotes, shipping and warranty. Prices remain indicative: every quote is calculated after diagnosis.',
  'MARQUES TRAIT?ES': 'BRANDS HANDLED',
  'La plupart des fabricants argentiques, français, japonais ou allemands.': 'Most French, Japanese and German film camera manufacturers.',
  "La liste n'est pas exhaustive et je ne sais pas tout faire :). Si votre matériel n'y figure pas, posez tout de même la question — je peux sûrement vous recommander un atelier partenaire qui pourra vous aider.": 'The list is not exhaustive and I cannot do everything :). If your equipment is not listed, ask anyway. I may be able to recommend a partner workshop that can help.',
  'Le devis est-il vraiment gratuit&nbsp;?': 'Is the quote really free?',
  'Oui. Vous payez seulement si vous validez la réparation.': 'Yes. You only pay if you approve the repair.',
  'Combien de temps pour une réparation&nbsp;?': 'How long does a repair take?',
  "La réparation est faite dans la foulée de l'acceptation du devis. Le délai d'attente est entre la réception de votre colis et la réalisation du devis.": 'The repair is carried out right after quote approval. The waiting time is between parcel reception and the quote being prepared.',
  'Et si c\'est irréparable&nbsp;?': 'What if it cannot be repaired?',
  'Ça arrive, rarement. Dans ce cas je vous le dis clairement, sans facturer le diagnostic.': 'It happens. In that case I will tell you clearly, without charging for the diagnosis.',
  'Comment envoyer le matériel&nbsp;?': 'How do I ship the equipment?',
  "Après validation de votre demande de prise en charge, vous recevez par email ou sur votre compte client, les instructions nécessaires pour m'envoyer votre matériel.": 'After your intake request is accepted, you receive the shipping instructions by email or in your customer account.',
  'Y a-t-il une garantie&nbsp;?': 'Is there a warranty?',
  '1 an sur la prestation et les pièces remplacées.': 'One year on the work performed and replaced parts.',
  'Vous déplacez-vous&nbsp;?': 'Do you travel?',
  'Sur Marseille et Aix-en-Provence, oui, pour des collections importantes.': 'Around Marseille and Aix-en-Provence, yes, for larger collections.',
  'une autre question ?': 'another question ?',
  'Services': 'Services',
  'Réparation photo argentique.': 'Film camera repair.',
  'Réparation': 'Repair',
  'photo argentique.': 'film camera repair.',
  'Quatre familles d’interventions — boîtiers, objectifs, accessoires, personnalisation. Pour chacune, la même approche : diagnostic franc, travail méticuleux, garantie un an.': 'Four families of work: cameras, lenses, accessories and customization. The same approach every time: honest diagnosis, careful work, one-year warranty.',
  'Contact': 'Contact',
  "L'atelier": 'The workshop',
  'Écrire à l’atelier': 'Write to the workshop',
  'Pour une réparation ou une prise en charge, passez par le formulaire de devis. Pour un échange déjà en cours, écrivez directement à l’adresse atelier.': 'For a repair or intake request, use the quote form. For an existing conversation, write directly to the workshop address.',
};

function hpTranslatePageText() {
  if (hpLang() !== 'en') return;

  const translateText = (text) => {
    const normalized = text.replace(/\s+/g, ' ').trim();
    return window.HPML_TEXT?.[`\n${normalized}`] || HOSTOPHOTO_TEXT_EN[normalized] || null;
  };

  const walk = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
      const parent = node.parentElement;
      if (!parent || ['SCRIPT', 'STYLE', 'TEXTAREA'].includes(parent.tagName)) return NodeFilter.FILTER_REJECT;
      return NodeFilter.FILTER_ACCEPT;
    },
  });

  const nodes = [];
  while (walk.nextNode()) nodes.push(walk.currentNode);
  nodes.forEach((node) => {
    const translated = translateText(node.nodeValue);
    if (translated) {
      const leading = node.nodeValue.match(/^\s*/)?.[0] || '';
      const trailing = node.nodeValue.match(/\s*$/)?.[0] || '';
      node.nodeValue = `${leading}${translated}${trailing}`;
    }
  });

  document.querySelectorAll('[placeholder]').forEach((element) => {
    const translated = translateText(element.getAttribute('placeholder') || '');
    if (translated) element.setAttribute('placeholder', translated);
  });
}

function hpInitialLang() {
  const config = window.HOSTOPHOTO_I18N || {};

  const firstPathPart = window.location.pathname.replace(/^\/+/, '').split('/')[0];
  if (firstPathPart === 'en') return 'en';
  if (firstPathPart) return 'fr';

  if (config.lang && HOSTOPHOTO_LANGS[config.lang]) return config.lang;

  const cookieMatch = document.cookie.match(/(?:^|;\s*)hostophoto_lang=(fr|en)(?:;|$)/);
  if (cookieMatch) return cookieMatch[1];

  const browserLang = (navigator.language || '').toLowerCase();
  return browserLang.startsWith('fr') ? 'fr' : 'en';
}

function hpSetLang(lang) {
  if (!HOSTOPHOTO_LANGS[lang]) return;
  document.documentElement.lang = HOSTOPHOTO_LANGS[lang].locale;
  document.cookie = `hostophoto_lang=${lang}; path=/; max-age=31536000; SameSite=Lax`;
}

function hpLang() {
  const lang = hpInitialLang();
  hpSetLang(lang);
  return lang;
}

function hpT(section, key) {
  const lang = hpLang();
  const translated = lang === 'en' && window.HPML_TEXT?.[`ui\n${section}.${key}`];
  if (typeof translated === 'string' && translated) return translated;
  return HOSTOPHOTO_UI[lang]?.[section]?.[key] || HOSTOPHOTO_UI.fr?.[section]?.[key] || key;
}

function hpTx(fr, en) {
  return hpLang() === 'en' ? (typeof fr === 'string' ? window.HPML_TEXT?.[`\n${fr}`] || en : en) : fr;
}

function hpRouteInfoFromPath(pathname = window.location.pathname) {
  const parts = pathname.replace(/^\/+|\/+$/g, '').split('/').filter(Boolean);
  const lang = parts[0] === 'en' ? 'en' : 'fr';
  const routeParts = lang === 'en' ? parts.slice(1) : parts;
  const head = routeParts[0] || '';
  const en = HOSTOPHOTO_ROUTE_SLUGS.en;
  const fr = HOSTOPHOTO_ROUTE_SLUGS.fr;

  if (!head) return { lang, page: 'home', parts: routeParts };
  if (head === fr.devis || head === en.devis) return { lang, page: 'devis', parts: routeParts };
  if (head === fr.services || head === en.services) return { lang, page: 'services', parts: routeParts };
  if (head === fr.faq || head === en.faq || head === 'tarifs') return { lang, page: 'faq', parts: routeParts };
  if (head === fr.blog || head === en.blog) return { lang, page: 'blog', parts: routeParts };
  if (head === fr.contact || head === en.contact) return { lang, page: 'contact', parts: routeParts };
  if (head === fr.compte || head === en.compte) return { lang, page: 'compte', parts: routeParts };
  if ((head === fr.article || head === en.article) && routeParts[1]) return { lang, page: 'article', slug: routeParts[1], parts: routeParts };
  return { lang, page: 'home', parts: routeParts };
}

function hpPath(page, lang = hpLang(), extra = '') {
  const slugs = HOSTOPHOTO_ROUTE_SLUGS[lang] || HOSTOPHOTO_ROUTE_SLUGS.fr;
  const prefix = HOSTOPHOTO_LANGS[lang]?.prefix || '';
  const slug = slugs[page] || '';
  const suffix = extra ? `/${String(extra).replace(/^\/+|\/+$/g, '')}` : '';
  const path = `${prefix}/${slug}${suffix}`.replace(/\/+/g, '/');
  return path === '' ? '/' : `${path.replace(/\/?$/, '/')}`;
}

function hpLocalizedPath(targetLang, pathname = window.location.pathname) {
  const info = hpRouteInfoFromPath(pathname);
  if (info.page === 'article' && info.slug) {
    const article = (window.HOSTOPHOTO_BLOG_POSTS || []).find(a => a.slug === info.slug || a.en?.slug === info.slug);
    if (article) return targetLang === 'en' ? (article.en?.permalink || article.permalink) : article.permalink;
    return hpPath('article', targetLang, info.slug);
  }
  return hpPath(info.page, targetLang);
}

function hpNormalizeRoutePath(pathname = window.location.pathname, search = window.location.search) {
  const info = hpRouteInfoFromPath(pathname);
  return {
    ...info,
    lang: hpLang(),
    normalizedPath: `/${info.parts.join('/')}${search}`.replace(/^\/\/+/, '/'),
  };
}

Object.assign(window, {
  HOSTOPHOTO_LANGS,
  HOSTOPHOTO_ROUTE_SLUGS,
  HOSTOPHOTO_UI,
  hpLang,
  hpT,
  hpTx,
  hpPath,
  hpSetLang,
  hpRouteInfoFromPath,
  hpLocalizedPath,
  hpNormalizeRoutePath,
  hpTranslatePageText,
});



/* src/layout.jsx */
/* Shared layout: header, footer, router */

const NAV_ITEMS = [
  { id: 'home', label: 'Accueil', href: '/' },
  { id: 'services', label: 'Services', href: '/services' },
  { id: 'devis', label: 'Demande de devis', href: '/devis' },
  { id: 'blog', label: 'Blog & tutoriels', href: '/blog' },
  { id: 'boutique', label: 'Boutique', href: '/boutique', noSpa: true },
  { id: 'contact', label: 'Contact', href: '/contact' },
];

function themeAsset(path) {
  const base = window.HOSTOPHOTO_THEME_URI || '';
  return `${base}/${path.replace(/^\/+/, '')}`;
}

function InstagramLink({ className = 'instagram-link' }) {
  return (
    <a href="https://www.instagram.com/hostophoto/" className={className} target="_blank" rel="noreferrer">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <rect x="3" y="3" width="18" height="18" rx="5"/>
        <circle cx="12" cy="12" r="4"/>
        <circle cx="17.5" cy="6.5" r="1.1" fill="currentColor" stroke="none"/>
      </svg>
      <span>{hpT('topbar', 'instagram')}</span>
    </a>
  );
}

function Topbar() {
  return (
    <div className="topbar">
      <div className="container inner">
        <div>{hpT('topbar', 'baseline')}</div>
        <div className="social">
          <InstagramLink />
        </div>
      </div>
    </div>
  );
}

function BrandMark({ size = 44 }) {
  return (
    <img src={themeAsset('assets/logo-hostophoto.png')} alt="HostoPhoto"
         decoding="async"
         style={{ height: size, width: 'auto', display:'block' }} />
  );
}

function LanguageSwitcher() {
  const currentLang = hpLang();
  const nextLang = currentLang === 'fr' ? 'en' : 'fr';

  return (
    <a
      href={hpLocalizedPath(nextLang)}
      className="language-switch"
      aria-label={hpT('language', 'aria')}
      data-no-spa="true"
      onClick={() => hpSetLang(nextLang)}
    >
      <span>{HOSTOPHOTO_LANGS[currentLang].short}</span>
      <strong>{HOSTOPHOTO_LANGS[nextLang].short}</strong>
    </a>
  );
}

function Header({ current, cart, cartUrl = '/panier/' }) {
  return (
    <header className="site-header">
      <div className="container inner">
        <nav className="nav">
          <a href={hpPath('services')} className={current === 'services' ? 'active' : ''}>{hpT('nav', 'services')}</a>
          <a href={hpPath('faq')} className={current === 'faq' ? 'active' : ''}>{hpT('nav', 'faq')}</a>
          <a href={hpPath('blog')} className={current === 'blog' ? 'active' : ''}>{hpT('nav', 'blog')}</a>
          <a href={hpPath('boutique')} data-no-spa="true" className={current === 'boutique' ? 'active' : ''}>{hpT('nav', 'boutique')}</a>
        </nav>
        <a href={hpPath('home')} className="brand">
          <BrandMark />
          <span className="brand-name">Hosto<em>Photo</em></span>
        </a>
        <div className="nav-right">
          <a href={hpPath('devis')} className={`header-quote-btn ${current === 'devis' ? 'active' : ''}`}>
            {hpT('nav', 'devis')}
          </a>
          <a href={hpPath('contact')} className={current === 'contact' ? 'active' : ''} style={{textDecoration:'none'}}>{hpT('nav', 'contact')}</a>
          <LanguageSwitcher />
          <a href={hpPath('compte')} className="icon-btn" aria-label={hpT('nav', 'account')} title={hpT('nav', 'account')} style={{textDecoration:'none'}}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
              <circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 4-6 8-6s8 2 8 6"/>
            </svg>
          </a>
          <a className="icon-btn" href={cartUrl} data-no-spa="true" aria-label={hpT('nav', 'cart')} title={hpT('nav', 'cart')} style={{textDecoration:'none'}}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
              <path d="M4 6h16l-2 12H6L4 6zM8 6V4a4 4 0 0 1 8 0v2"/>
            </svg>
            {cart > 0 && <span className="cart-count">{cart}</span>}
          </a>
        </div>
      </div>
    </header>
  );
}

function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="grid">
          <div>
            <div style={{display:'flex', alignItems:'center', gap:12, marginBottom:16}}>
              <BrandMark size={36} />
              <span style={{fontFamily:'var(--font-display)', fontWeight:600, fontSize:20}}>HostoPhoto</span>
            </div>
            <p className="tagline">{hpT('footer', 'tagline')}</p>
          </div>
          <div>
            <h4>{hpT('footer', 'services')}</h4>
            <a href={hpPath('services')}>{hpT('footer', 'interventions')}</a>
            <a href={hpPath('faq')}>{hpT('footer', 'faq')}</a>
            <a href={hpPath('devis')}>{hpT('footer', 'quote')}</a>
            <a href={hpPath('contact')}>{hpT('footer', 'address')}</a>
          </div>
          <div>
            <h4>{hpT('footer', 'resources')}</h4>
            <a href={hpPath('blog')}>{hpT('footer', 'articles')}</a>
            <a href={hpPath('blog')}>{hpT('footer', 'cameraTutorials')}</a>
            <a href={hpPath('blog')}>{hpT('footer', 'lensTutorials')}</a>
            <a href={hpPath('blog')}>{hpT('footer', 'diy')}</a>
            <a href={`${hpLang() === 'en' ? '/en' : ''}/mentions-legales/`} data-no-spa="true">{hpTx('Mentions légales', 'Legal notice')}</a>
            <a href={`${hpLang() === 'en' ? '/en' : ''}/politique-de-confidentialite/`} data-no-spa="true">{hpTx('Confidentialité', 'Privacy policy')}</a>
            <a href={`${hpLang() === 'en' ? '/en' : ''}/politique-de-cookies-ue/`} data-no-spa="true">{hpTx('Cookies', 'Cookie policy')}</a>
          </div>
          <div>
            <h4>{hpT('footer', 'workshop')}</h4>
            <p style={{fontSize:14, opacity:0.8, marginTop:0, lineHeight:1.7}}>
              {hpTx('Atelier à Bouc-Bel-Air (13320), entre Marseille et Aix-en-Provence. Dépôt uniquement sur rendez-vous, après accord de prise en charge.', 'Workshop in Bouc-Bel-Air (13320), between Marseille and Aix-en-Provence. Drop-off by appointment only, after intake approval.')}
            </p>
            <div style={{display:'grid', gap:8, marginTop:12}}>
              <a href="mailto:atelier@hostophoto.fr">atelier@hostophoto.fr</a>
              {hpLang() === 'fr' && <a href="/a-propos/" data-no-spa="true">À propos de l’atelier</a>}
              <a href={hpPath('devis')}>{hpT('footer', 'request')}</a>
              <a href={hpPath('compte')}>{hpT('footer', 'tracking')}</a>
              <InstagramLink className="instagram-link footer-instagram-link" />
            </div>
          </div>
        </div>
        <div className="bottom">
          <span>{hpT('footer', 'copyright')}</span>
          <span>{hpT('footer', 'claim')}</span>
        </div>
      </div>
    </footer>
  );
}

function applyTweaks(t) {
  const root = document.documentElement.style;
  if (t.accent) root.setProperty('--accent', t.accent);
  if (t.accentDeep) root.setProperty('--accent-deep', t.accentDeep);
  if (t.fontDisplay) root.setProperty('--font-display', t.fontDisplay);
  if (t.fontBody) root.setProperty('--font-body', t.fontBody);
  if (t.paperMode === 0) {
    root.setProperty('--paper', '#f4efe6');
    root.setProperty('--paper-2', '#ebe4d6');
    root.setProperty('--ink', '#1a1612');
    root.setProperty('--ink-soft', '#3a332b');
    root.setProperty('--muted', '#7a6f62');
    root.setProperty('--hair', 'rgba(26,22,18,0.12)');
  } else if (t.paperMode === 1) {
    root.setProperty('--paper', '#faf7f2');
    root.setProperty('--paper-2', '#efeae0');
    root.setProperty('--ink', '#1a1612');
    root.setProperty('--ink-soft', '#3a332b');
    root.setProperty('--muted', '#8a7f72');
    root.setProperty('--hair', 'rgba(26,22,18,0.10)');
  } else if (t.paperMode === 2) {
    root.setProperty('--paper', '#1a1612');
    root.setProperty('--paper-2', '#241f1a');
    root.setProperty('--ink', '#f4efe6');
    root.setProperty('--ink-soft', '#d6cfc1');
    root.setProperty('--muted', '#8a7f72');
    root.setProperty('--hair', 'rgba(244,239,230,0.12)');
  }
}

Object.assign(window, { Header, Footer, Topbar, BrandMark, LanguageSwitcher, applyTweaks, themeAsset, NAV_ITEMS });



/* src/home.jsx */
﻿/* Home page */

function HeroEditorial() {
  return (
    <section style={{paddingTop:80, paddingBottom:100, position:'relative'}}>
      <div className="container">
        <div className="hp-split hp-split-hero" style={{alignItems:'end'}}>
          <div>
            <div className="kicker" style={{marginBottom:28}}>{hpTx('EST. 2014 · ATELIER MARSEILLE / AIX · RÉPARATION ARGENTIQUE', 'EST. 2014 · MARSEILLE / AIX WORKSHOP · FILM CAMERA REPAIR')}</div>
            <h1 style={{fontSize:'clamp(2.7rem, 6.2vw, 5.2rem)', lineHeight:0.98, marginBottom:32}}>
              {hpLang() === 'en' ? (
                <>A second<br/><em style={{fontStyle:'italic', color:'var(--accent)'}}>life</em> for<br/>your film gear.</>
              ) : (
                <>Une seconde<br/><em style={{fontStyle:'italic', color:'var(--accent)'}}>jeunesse</em> pour<br/>votre argentique.</>
              )}
            </h1>
            <p className="lede" style={{maxWidth:540, marginBottom:40}}>
              {hpTx(
                'Entretien, réparation, sauvetages et petits miracles\u00a0— depuis 2014, je rends leur souffle aux boîtiers reflex, TLR bi-objectif et objectifs en tous genres.',
                'Maintenance, repair, rescues and small miracles. Since 2014, I have been bringing SLRs, twin-lens reflex cameras and all kinds of lenses back to life.'
              )}
            </p>
            <div style={{display:'flex', gap:12, flexWrap:'wrap'}}>
              <a href={hpPath('devis')} className="btn">{hpTx('Demander un devis', 'Request a quote')} <span className="arrow"/></a>
            </div>
          </div>
          <div style={{position:'relative'}}>
            <div className="home-hero-media-frame" style={{width:'100%', height:'clamp(360px, 42vw, 520px)', borderRadius:4, background:'var(--ink)', overflow:'hidden', display:'grid', placeItems:'center', position:'relative'}}>
              <img src={themeAsset('assets/rollei-reparation-boitier.webp')} alt={hpTx('Rolleiflex démonté en vue éclatée', 'Exploded view of a dismantled Rolleiflex')}
                   decoding="async"
                   style={{
                     position:'absolute', inset:0,
                     width:'100%', height:'100%', objectFit:'contain', objectPosition:'center',
                     opacity: 0,
                     willChange:'opacity',
                   }}/>
              <img
                className="hero-rollei-overlay"
                src={themeAsset('assets/rollei-schema-overlay-aligned.webp')}
                alt=""
                aria-hidden="true"
                decoding="async"
                style={{
                  display:'none',
                }}
              />
              <img src={themeAsset('assets/home-atelier-hero.webp')} alt={hpTx("Nettoyage d'un boitier argentique à l'atelier", 'Cleaning a film camera in the workshop')}
                   decoding="async" fetchPriority="high"
                   style={{position:'absolute', inset:0, width:'100%', height:'100%', objectFit:'cover', objectPosition:'center', display:'block'}}/>
            </div>
            <div className="home-hero-caption" style={{
              position:'absolute', bottom:-20, left:-40,
              background:'var(--paper)', border:'1px solid var(--ink)',
              padding:'16px 20px', maxWidth:240,
              fontFamily:'var(--font-mono)', fontSize:11, letterSpacing:'0.08em',
            }}>
              {hpTx('Service complet sur un Rolleiflex 2.8. Bon pour 10 ans de service.', 'Full service on a Rolleiflex 2.8. Ready for another 10 years of use.')}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function HeroAtelier() {
  return (
    <section style={{paddingTop:60, paddingBottom:80}}>
      <div className="container">
        <div className="hp-panel hp-split hp-hero-card" style={{
          background:'var(--ink)', color:'var(--paper)',
          borderRadius:8, padding:'80px 64px',
          position:'relative', overflow:'hidden',
        }}>
          <div style={{position:'relative', zIndex:2}}>
            <div style={{fontFamily:'var(--font-mono)', fontSize:11, letterSpacing:'0.2em', opacity:0.7, marginBottom:24}}>
              L'ATELIER · BULLETIN N°47
            </div>
            <h1 style={{color:'var(--paper)', fontSize:'clamp(2.5rem, 5.5vw, 4.5rem)', lineHeight:1, marginBottom:28}}>
              Vos appareils<br/>
              sont vivants.<br/>
              <em style={{fontStyle:'italic', color:'var(--highlight)'}}>Prenez-en soin.</em>
            </h1>
            <p style={{fontSize:18, lineHeight:1.5, maxWidth:440, opacity:0.85, marginBottom:36}}>
              Je répare vos boîtiers reflex, TLR moyen format, objectifs, obturateurs et cellules&nbsp;— dans le respect des pièces d'origine.
            </p>
            <div style={{display:'flex', gap:12}}>
              <a href="/devis" className="btn accent">Demander un devis <span className="arrow"/></a>
              <a href="/blog" style={{color:'var(--paper)', textDecoration:'underline', textUnderlineOffset:6, padding:'14px 0', fontSize:14}}>Explorer les tutoriels →</a>
            </div>
          </div>
          <div style={{position:'relative'}}>
            <div className="placeholder-img" style={{aspectRatio:'4/5', borderRadius:4, background:'#15110c'}}>
              <span style={{color:'rgba(232,199,122,0.5)'}}>établi — outils étalés<br/>sur toile de jute</span>
            </div>
          </div>
          {/* Decorative film perforations */}
          <div style={{
            position:'absolute', top:0, bottom:0, left:0, width:20,
            background:'repeating-linear-gradient(180deg, rgba(244,239,230,0.1) 0 4px, transparent 4px 10px)',
          }}/>
          <div style={{
            position:'absolute', top:0, bottom:0, right:0, width:20,
            background:'repeating-linear-gradient(180deg, rgba(244,239,230,0.1) 0 4px, transparent 4px 10px)',
          }}/>
        </div>

        <div className="hp-grid-3" style={{
          gap:24, marginTop:48,
        }}>
          {[
            { t: 'Diagnostic honnête', d: 'Devis avant toute intervention. Si c\'est irréparable, vous le saurez.' },
            { t: 'Pièces d\'origine', d: 'Réseau de pièces détachées, cannibalisation raisonnée, fabrication maison.' },
            { t: 'Garantie 1 an', d: 'Sur la prestation et les pièces remplacées.' },
          ].map((f, i) => (
            <div key={i} style={{padding:'24px 0', borderTop:'1px solid var(--hair)'}}>
              <div style={{fontFamily:'var(--font-mono)', fontSize:11, letterSpacing:'0.14em', color:'var(--accent)', marginBottom:12}}>0{i+1}</div>
              <h3 style={{fontSize:'1.25rem', marginBottom:8}}>{f.t}</h3>
              <p style={{color:'var(--muted)', fontSize:14, margin:0}}>{f.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function HeroFilmStrip() {
  return (
    <section style={{paddingTop:72, paddingBottom:100}}>
      <div className="container">
        <div style={{textAlign:'center', marginBottom:56}}>
          <div className="kicker" style={{marginBottom:20}}>HOSTOPHOTO · L'HÔPITAL DE VOTRE ARGENTIQUE</div>
          <h1 style={{fontSize:'clamp(3rem, 8vw, 7rem)', lineHeight:0.92, maxWidth:1100, margin:'0 auto'}}>
            Le réparateur <em style={{fontStyle:'italic', color:'var(--accent)'}}>photo</em><br/>
            de votre matériel argentique.
          </h1>
          <p className="lede" style={{maxWidth:640, margin:'36px auto 0'}}>
            Depuis 2014, HostoPhoto rend une nouvelle jeunesse à vos boîtiers, objectifs, obturateurs et cellules.
          </p>
          <div style={{display:'flex', gap:12, justifyContent:'center', marginTop:36}}>
            <a href="/devis" className="btn">Demander un devis <span className="arrow"/></a>
            <a href="/contact" className="btn ghost">Visiter l'atelier</a>
          </div>
        </div>

        <div className="film-strip" style={{marginTop:80}}>
          {['canon a1 — vue 3/4', 'yashica mat', 'takumar 55mm', 'pentax s1a', 'olympus om zuiko', 'canon fd', 'mamiya sekor'].map((lbl, i) => (
            <div key={i} className="frame">
              <div className="placeholder-img" style={{height:'100%', background:'transparent', color:'rgba(244,239,230,0.35)', fontSize:9}}>
                {lbl}
              </div>
              <div style={{
                position:'absolute', bottom:4, left:4,
                fontFamily:'var(--font-mono)', fontSize:9, color:'rgba(244,239,230,0.5)',
              }}>
                0{i+1}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function HomeServicesStrip() {
  const services = [
    { n: '01', t: hpTx('Diagnostic', 'Diagnosis'), img: 'diagnostic.webp', gif: 'diagnostic-anim.webp', d: hpTx('Étude approfondie de votre matériel, avec retour honnête sur sa réparabilité.', 'A careful assessment of your equipment, with an honest opinion on whether it can be repaired.') },
    { n: '02', t: hpTx('Nettoyage complet', 'Full cleaning'), img: 'nettoyage.webp', gif: 'nettoyage-anim.webp', d: hpTx('Démontage, dépoussiérage des mécanismes, lentilles, viseur.', 'Disassembly, dust removal and cleaning of mechanisms, lenses and viewfinder.') },
    { n: '03', t: hpTx('Réparation', 'Repair'), img: 'reparation.webp', gif: 'reparation-anim.webp', d: hpTx('Remplacement des pièces défectueuses, ajustement des mécaniques.', 'Replacement of faulty parts and mechanical adjustment.') },
    { n: '04', t: hpTx('Réglage & calibration', 'Adjustment & calibration'), img: 'calibration.webp', gif: 'calibration-anim.webp', d: hpTx("Vitesses d'obturation, cellule, montée du miroir, parallaxe.", 'Shutter speeds, light meter, mirror travel and parallax.') },
  ];

  return (
    <section className="section" style={{background:'var(--paper-2)', margin:'40px 0', padding:'80px 0'}}>
      <div className="container">
        <div className="section-title" style={{borderBottom:'1px solid var(--rule)'}}>
          <div>
            <div className="kicker" style={{marginBottom:12}}>{hpTx('CE QUE JE FAIS', 'WHAT I DO')}</div>
            <h2>{hpTx('Interventions courantes.', 'Common workshop jobs.')}</h2>
          </div>
          <a href={hpPath('faq')} className="linky">{hpTx('voir la FAQ →', 'read the FAQ →')}</a>
        </div>
        <div className="hp-grid-4 hp-service-strip-grid" style={{gap:0}}>
          {services.map((s, i) => (
            <div key={i} style={{
              padding:'24px 28px 28px',
              borderLeft: i > 0 ? '1px solid var(--hair)' : 'none',
            }}>
              <HomeInterventionVisual image={s.img} gif={s.gif} label={s.t} />
              <div style={{fontFamily:'var(--font-mono)', fontSize:11, letterSpacing:'0.16em', color:'var(--accent)', marginBottom:16}}>{s.n}</div>
              <h3 style={{fontSize:'1.5rem', fontWeight:500, marginBottom:12}}>{s.t}</h3>
              <p style={{color:'var(--ink-soft)', fontSize:14.5, lineHeight:1.55, margin:0}}>{s.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function HomeInterventionVisual({ image, gif, label }) {
  const [gifEnabled, setGifEnabled] = React.useState(false);
  const [isActive, setIsActive] = React.useState(false);
  const activate = () => {
    setGifEnabled(true);
    setIsActive(true);
  };

  return (
    <div
      className={`home-intervention-visual${isActive ? ' is-active' : ''}`}
      onMouseEnter={activate}
      onPointerEnter={activate}
      onFocus={activate}
      onClick={activate}
      onTouchStart={activate}
      onMouseLeave={() => setIsActive(false)}
      onBlur={() => setIsActive(false)}
      tabIndex="0"
      aria-label={`${label} — ${hpTx('animation au survol', 'animation on hover')}`}
    >
      <img className="home-intervention-static" src={themeAsset(`assets/interventions/${image}`)} alt="" aria-hidden="true" loading="lazy" decoding="async" />
      {gifEnabled && (
        <img className="home-intervention-gif" src={themeAsset(`assets/interventions/${gif}`)} alt="" aria-hidden="true" loading="lazy" decoding="async" />
      )}
    </div>
  );
}

function HomeBlogGrid() {
  const allArticles = Array.isArray(window.HOSTOPHOTO_BLOG_POSTS) && window.HOSTOPHOTO_BLOG_POSTS.length
    ? window.HOSTOPHOTO_BLOG_POSTS
    : ARTICLES;
  const sourceArticles = hpLang() === 'en'
    ? allArticles.filter(article => article?.en?.available)
    : allArticles;
  const items = sourceArticles.slice(0, 5);
  const hero = items[0];
  const rest = items.slice(1);
  const articleField = (article, field) => {
    if (hpLang() === 'en' && article?.en?.[field]) return article.en[field];
    return article?.[field] || '';
  };
  const articleUrl = (article) => {
    if (hpLang() === 'en' && article?.en?.permalink) return article.en.permalink;
    return article.permalink || `/article/${article.slug}/`;
  };
  const articleCategory = (category) => {
    const map = {
      'Matériel': 'Equipment',
      'Boitier': 'Camera body',
      'Boîtier': 'Camera body',
      'Objectif': 'Lens',
      'Objectifs': 'Lenses',
      'Asahi Pentax': 'Asahi Pentax',
    };
    return hpLang() === 'en' ? (map[category] || category) : category;
  };
  const readTime = (value) => hpLang() === 'en' ? `${String(value || '').replace(/ de lecture$/i, '')} read` : `${value} de lecture`;
  return (
    <section className="section">
      <div className="container">
        <div className="section-title">
          <div>
            <div className="kicker" style={{marginBottom:12}}>{hpTx('DERNIERS TUTORIELS', 'LATEST WORKSHOP POSTS')}</div>
            <h2>{hpTx("Sur l'établi, ce mois-ci.", 'On the bench this month.')}</h2>
          </div>
          <a href={hpPath('blog')} className="linky">{hpTx('tout le blog →', 'all posts →')}</a>
        </div>

        <div className="hp-split hp-split-feature">
          <a href={articleUrl(hero)} data-no-spa="true" className="card-article">
            <ArticleThumb article={hero} />
            <div className="meta">
              <span className="tag">{articleCategory(articleField(hero, 'category') || hero.category)}</span>
              <span>{articleField(hero, 'date') || hero.date}</span>
              <span>{readTime(hero.readTime)}</span>
            </div>
            <h3 style={{fontSize:'2.25rem', fontWeight:500, maxWidth:560}}>{articleField(hero, 'title')}</h3>
            <p style={{color:'var(--ink-soft)', fontSize:16.5, lineHeight:1.55, margin:0, maxWidth:560}}>{articleField(hero, 'excerpt')}</p>
          </a>
          <div style={{display:'grid', gap:24, alignContent:'start'}}>
            {rest.map(a => (
              <a key={a.slug} href={articleUrl(a)} data-no-spa="true" className="card-article"
                 style={{flexDirection:'row', gap:18, alignItems:'start'}}>
                <div style={{width:140, flexShrink:0}}>
                  <ArticleThumb article={a} />
                </div>
                <div style={{flex:1}}>
                  <div className="meta" style={{marginBottom:6}}>
                    <span className="tag">{articleCategory(articleField(a, 'category') || a.category)}</span>
                    <span>{articleField(a, 'date') || a.date}</span>
                  </div>
                  <h3 style={{fontSize:'1.125rem', fontWeight:500, lineHeight:1.25}}>{articleField(a, 'title')}</h3>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function HomeQuoteCTA() {
  return (
    <section style={{padding:'100px 0', background:'var(--paper-2)', color:'var(--ink)', position:'relative', overflow:'hidden'}}>
      <div className="container" style={{position:'relative', zIndex:2}}>
        <div className="hp-split" style={{alignItems:'center'}}>
          <div>
            <div style={{fontFamily:'var(--font-mono)', fontSize:11, letterSpacing:'0.18em', color:'var(--highlight)', marginBottom:20}}>
              {hpTx("UN DEVIS, C'EST GRATUIT", 'QUOTE REQUESTS ARE FREE')}
            </div>
            <h2 style={{color:'var(--ink)', fontSize:'clamp(2rem, 4.5vw, 3.5rem)', lineHeight:1.05, marginBottom:24}}>
              {hpTx('Vous pensez que votre appareil est irréparable\u00a0?', 'Think your camera is beyond repair?')}
              <br/>
              <em style={{fontStyle:'italic', color:'var(--highlight)'}}>{hpTx("Demandez d'abord.", 'Ask first.')}</em>
            </h2>
            <p style={{maxWidth:480, opacity:0.8, fontSize:17, lineHeight:1.55, marginBottom:28}}>
              {hpTx(
                '90% des cas considérés comme « morts » peuvent être sauvés. Envoyez-moi une description et quelques photos, je vous donne mon avis :) .',
                'Many cameras considered “dead” can still be saved. Send me a description and a few photos, and I will give you my opinion.'
              )}
            </p>
            <a href={hpPath('devis')} className="btn accent">{hpTx('Lancer la demande', 'Start the request')} <span className="arrow"/></a>
          </div>
          <div style={{
            display:'grid', gap:16, fontFamily:'var(--font-mono)', fontSize:12,
            letterSpacing:'0.08em',
          }}>
            {[
              ['01.', hpTx('Vous m\'envoyez description + photos', 'Send a description + photos')],
              ['02.', hpTx('Je réponds avec un premier avis', 'I reply with an initial opinion')],
              ['03.', hpTx('Si OK, vous envoyez le matériel par colis', 'If accepted, ship the equipment')],
              ['04.', hpTx('Réparation. Tests. Retour.', 'Repair. Testing. Return shipping.')],
            ].map(([n, t]) => (
              <div key={n} style={{display:'flex', gap:20, padding:'18px 0', borderTop:'1px solid var(--hair)'}}>
                <span style={{color:'var(--accent)'}}>{n}</span>
                <span style={{opacity:0.85}}>{t}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function HomeShopTeaser() {
  const wc = window.HOSTOPHOTO_WOOCOMMERCE || {};
  const products = wc.enabled && Array.isArray(wc.products) && wc.products.length > 0 ? wc.products : PRODUCTS;
  const items = products.slice(0, 4);

  function imageFor(product) {
    return product.image || product.imageLarge || null;
  }

  function priceFor(product) {
    if (product.priceHtml) return <span dangerouslySetInnerHTML={{__html: product.priceHtml}} />;
    return `${Number(product.price || 0).toFixed(2)}€`;
  }

  function badgeFor(product) {
    const badge = product.badge || product.category || 'Boutique';
    const map = {
      'Boutique': 'Shop',
      'Objectifs': 'Lenses',
      'Objectif': 'Lens',
      'Appareil photo': 'Camera',
      'Accessoires': 'Accessories',
      'Pièces détachées': 'Spare parts',
      'Livre': 'Book',
      'Outils': 'Tools',
      'Logiciels': 'Software',
    };
    return hpLang() === 'en' ? (map[badge] || badge) : badge;
  }

  return (
    <section className="section">
      <div className="container">
        <div className="section-title">
          <div>
            <div className="kicker" style={{marginBottom:12}}>{hpTx('LA BOUTIQUE', 'THE SHOP')}</div>
            <h2>{hpTx('Matériel révisé, certifié & garanti.', 'Checked, certified and guaranteed equipment.')}</h2>
          </div>
          <a href={hpPath('boutique')} data-no-spa="true" className="linky">{hpTx('toute la boutique →', 'open the shop →')}</a>
        </div>
        <div className="home-shop-showcase">
          {items.map(p => (
            <a key={p.slug} href={p.permalink || `/boutique/${p.slug}`} data-no-spa="true" className="home-product-card">
              <div className="home-product-media">
                {imageFor(p) ? (
                  <img src={imageFor(p)} alt={p.name} loading="lazy" decoding="async" />
                ) : (
                  <div className="placeholder-img" style={{background:'transparent', color:'var(--muted)'}}>{p.name}</div>
                )}
              </div>
              <div className="home-product-body">
                <div>
                  <div className="home-product-badge">{badgeFor(p)}</div>
                  <h3>{p.name}</h3>
                </div>
                <div className="home-product-foot">
                  <span className="home-product-price">{priceFor(p)}</span>
                  <span className="home-product-link">{hpTx('Voir le produit', 'View product')}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

function HomeYoutube() {
  const videos = (Array.isArray(window.HOSTOPHOTO_BLOG_POSTS) ? window.HOSTOPHOTO_BLOG_POSTS : [])
    .filter(article => article.image)
    .slice(0, 3);
  const fallback = ['Canon A1 — démontage', 'Takumar 55mm — diaph', 'Yashica Mat — révision'];

  return (
    <section className="section" style={{paddingTop:0}}>
      <div className="container">
        <div className="hp-panel hp-split hp-split-media-wide" style={{
          alignItems:'center',
          padding:'56px 48px',
          border:'1px solid var(--hair)',
          borderRadius:8,
          background:'var(--paper-2)',
        }}>
          <div>
            <div className="kicker" style={{marginBottom:16}}>LA CHAÎNE YOUTUBE</div>
            <h2 style={{fontSize:'2.5rem', marginBottom:20}}>Chaque tutoriel est aussi en vidéo.</h2>
            <p style={{color:'var(--ink-soft)', marginBottom:28}}>
              Démontage pas à pas, outils utilisés, astuces d'atelier. Les contenus vidéo sont relayés depuis le blog et les démonstrations de l'atelier.
            </p>
            <a href="/blog" className="btn ghost">Voir les tutoriels <span className="arrow"/></a>
          </div>
          <div className="hp-grid-3" style={{gap:12}}>
            {(videos.length ? videos : fallback).map((item, i) => {
              const article = typeof item === 'string' ? null : item;
              const label = article ? articleField(article, 'title') : item;
              return (
              <a key={article?.slug || i} href={article ? articleUrl(article) : hpPath('blog')} data-no-spa={article ? 'true' : undefined} style={{aspectRatio:'16/10', position:'relative', borderRadius:4, overflow:'hidden', display:'block', background:'var(--ink)', color:'var(--paper)', textDecoration:'none'}}>
                {article ? (
                  <img src={article.imageLarge || article.image} alt={label}
                       loading="lazy" decoding="async"
                       style={{width:'100%', height:'100%', objectFit:'cover', display:'block', filter:'saturate(0.9) contrast(1.05)'}}/>
                ) : (
                  <div className="placeholder-img">{label}</div>
                )}
                <div style={{
                  position:'absolute', inset:0, display:'grid', placeItems:'center',
                  background:'linear-gradient(to top, rgba(0,0,0,0.45), transparent 60%)',
                }}>
                  <div style={{
                    width:48, height:48, borderRadius:'50%',
                    background:'var(--paper)', display:'grid', placeItems:'center',
                  }}>
                    <div style={{
                      width:0, height:0,
                      borderLeft:'12px solid var(--ink)',
                      borderTop:'8px solid transparent',
                      borderBottom:'8px solid transparent',
                      marginLeft:3,
                    }}/>
                  </div>
                </div>
                <div style={{position:'absolute', left:12, right:12, bottom:10, fontFamily:'var(--font-mono)', fontSize:10, color:'var(--paper)', letterSpacing:'0.08em'}}>
                  {label}
                </div>
              </a>
            )})}
          </div>
        </div>
      </div>
    </section>
  );
}

function HomePage({ heroVariant }) {
  return (
    <>
      {heroVariant === 0 && <HeroEditorial />}
      {heroVariant === 1 && <HeroAtelier />}
      {heroVariant === 2 && <HeroFilmStrip />}
      <HomeServicesStrip />
      <HomeBrandsCarousel />
      <HomeShopTeaser />
      <HomeBlogGrid />
      <HomeQuoteCTA />
    </>
  );
}

Object.assign(window, { HomePage });

function HomeBrandsCarousel() {
  const brands = [
    { name: 'Canon', asset: 'assets/brand-logos/canon.svg' },
    { name: 'Nikon', asset: 'assets/brand-logos/nikon.svg' },
    { name: 'Pentax', asset: 'assets/brand-logos/pentax.svg' },
    { name: 'Minolta', asset: 'assets/brand-logos/minolta.svg' },
    { name: 'Yashica', asset: 'assets/brand-logos/yashica.svg' },
    { name: 'Leica', asset: 'assets/brand-logos/leica.svg' },
    { name: 'Contax', asset: 'assets/brand-logos/contax.svg' },
    { name: 'Rolleiflex', asset: 'assets/brand-logos/rollei.svg', alt: 'Rollei / Rolleiflex' },
    { name: 'Hasselblad', asset: 'assets/brand-logos/hasselblad.svg' },
    { name: 'Mamiya', asset: 'assets/brand-logos/mamiya.svg' },
    { name: 'Voigtländer', asset: 'assets/brand-logos/voigtlander.svg' },
    { name: 'Zeiss Ikon', asset: 'assets/brand-logos/zeiss-ikon.svg' },
    { name: 'Konica', asset: 'assets/brand-logos/konica.svg' },
    { name: 'Fujica', asset: 'assets/brand-logos/fujifilm.svg', alt: 'Fujifilm / Fujica' },
  ];
  const loop = [...brands, ...brands]; // duplicated for seamless scroll
  const brandClass = (brand) => (brand.variant || brand.name)
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

  return (
    <section className="brands-carousel" style={{
      padding: '64px 0',
      borderTop: '1px solid rgba(255,255,255,0.08)',
      borderBottom: '1px solid rgba(255,255,255,0.08)',
      background: '#1a1612',
      color: '#f4efe6',
      overflow: 'hidden',
      position: 'relative',
    }}>
      <div className="container" style={{marginBottom: 32, display:'flex', justifyContent:'space-between', alignItems:'baseline', flexWrap:'wrap', gap:16}}>
        <div className="kicker" style={{color:'var(--accent)', background:'transparent', padding:0}}>{hpTx('MARQUES TRAITÉES · ATELIER HOSTOPHOTO', 'BRANDS SERVICED · HOSTOPHOTO WORKSHOP')}</div>
        <div style={{fontFamily:'var(--font-mono)', fontSize:11, letterSpacing:'0.14em', textTransform:'uppercase', color:'rgba(244,239,230,0.5)'}}>
          {hpTx("+ 60 ans d'argentique sur l'établi", '+ 60 years of film gear on the bench')}
        </div>
      </div>

      <div className="brands-track-wrap">
        <div className="brands-track">
          {loop.map((b, i) => (
            <div key={i} className={`brand-logo-pill brand-logo-${brandClass(b)}`} aria-hidden={i >= brands.length ? true : undefined} aria-label={b.alt || b.name} title={b.alt || b.name}>
              {b.asset ? (
                <img src={`${themeAsset(b.asset)}?v=brand-logos-20260526`} alt={b.alt || b.name} loading="lazy" decoding="async" />
              ) : (
                <span>{b.mark}</span>
              )}
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .brands-track-wrap {
          position: relative;
          width: 100%;
          mask-image: linear-gradient(to right, transparent 0, #000 8%, #000 92%, transparent 100%);
          -webkit-mask-image: linear-gradient(to right, transparent 0, #000 8%, #000 92%, transparent 100%);
        }
        .brands-track {
          display: flex;
          gap: 36px;
          width: max-content;
          animation: brands-scroll 60s linear infinite;
        }
        .brand-logo-pill {
          width: 184px;
          min-width: 184px;
          height: 76px;
          display: grid;
          place-items: center;
          opacity: 0.72;
          transition: opacity 0.3s ease, transform 0.3s ease;
          white-space: nowrap;
        }
        .brand-logo-pill img {
          display: block;
          width: 156px;
          height: 46px;
          object-fit: contain;
          object-position: center;
          filter: brightness(0) saturate(100%) invert(93%) sepia(7%) saturate(383%) hue-rotate(347deg) brightness(105%) contrast(91%);
        }
        .brand-logo-hasselblad {
          width: 252px;
          min-width: 252px;
        }
        .brand-logo-hasselblad img {
          width: 236px;
        }
        .brand-logo-voigtlander img {
          width: 184px;
        }
        .brand-logo-fujica img {
          width: 176px;
        }
        .brand-logo-leica img,
        .brand-logo-rollei img {
          width: 150px;
        }
        .brand-logo-konica img {
          width: 150px;
        }
        .brand-logo-pill span {
          display: block;
          color: #f4efe6;
          font-size: clamp(1.6rem, 3vw, 2.65rem);
          line-height: 1;
          letter-spacing: 0.03em;
        }
        .brand-logo-pill:hover {
          opacity: 1;
          transform: translateY(-2px);
        }
        .brands-carousel:hover .brands-track {
          animation-play-state: paused;
        }
        @keyframes brands-scroll {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        @media (prefers-reduced-motion: reduce) {
          .brands-track { animation: none; }
        }
      `}</style>
    </section>
  );
}




/* src/blog.jsx */
/* Blog listing + single article */

const BLOG_ARTICLES = Array.isArray(window.HOSTOPHOTO_BLOG_POSTS) && window.HOSTOPHOTO_BLOG_POSTS.length
  ? window.HOSTOPHOTO_BLOG_POSTS
  : ARTICLES;
const VISIBLE_BLOG_ARTICLES = hpLang() === 'en'
  ? BLOG_ARTICLES.filter(article => article?.en?.available)
  : BLOG_ARTICLES;

function articleField(article, field) {
  if (hpLang() === 'en' && article?.en?.[field]) return article.en[field];
  return article?.[field] || '';
}

function articleUrl(article) {
  if (hpLang() === 'en' && article?.en?.permalink) return article.en.permalink;
  return article.permalink || `/article/${article.slug}/`;
}

function articleImage(article, large = false) {
  return large ? (articleField(article, 'imageLarge') || articleField(article, 'image') || null) : (articleField(article, 'image') || articleField(article, 'imageLarge') || null);
}

function ArticleThumb({ article, ratio = '4/3', large = false }) {
  const image = articleImage(article, large);

  return (
    <div className="thumb" style={{aspectRatio:ratio}}>
      {image ? (
        <img
          src={image}
          alt={articleField(article, 'cover') || articleField(article, 'title')}
          loading="lazy"
          decoding="async"
          style={{width:'100%', height:'100%', objectFit:'cover', display:'block'}}
        />
      ) : (
        <div className="placeholder-img">{article.cover || articleField(article, 'title')}</div>
      )}
    </div>
  );
}

function ElementorMediaGrid({ items = [] }) {
  if (!Array.isArray(items) || !items.length) return null;

  return (
    <div className="article-elementor-media">
      <div className="kicker" style={{marginBottom:18}}>{hpTx("RESSOURCES DE L'ARTICLE", 'ARTICLE RESOURCES')}</div>
      <div className="article-elementor-media-grid">
        {items.map((item, index) => {
          const image = (
            <img
              src={item.large || item.src}
              alt={item.alt || ''}
              loading="lazy"
              decoding="async"
            />
          );
          return (
            <figure key={`${item.src}-${index}`}>
              {item.link ? (
                <a href={item.link} target="_blank" rel="noreferrer">{image}</a>
              ) : image}
              {item.link && <figcaption>{hpTx("Document lié à l'article", 'Linked document')}</figcaption>}
            </figure>
          );
        })}
      </div>
    </div>
  );
}

function ArticleVideos({ videos = [] }) {
  if (!Array.isArray(videos) || !videos.length) return null;

  return (
    <div className="article-video-list">
      {videos.map((video, index) => (
        <figure className="article-video-card" key={video.id || video.embed || index}>
          <div className="article-video-frame">
            <iframe
              src={video.embed}
              title={`HostoPhoto video ${index + 1}`}
              loading="lazy"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
          <figcaption>{hpTx('Vidéo liée à l’article', 'Related workshop video')}</figcaption>
        </figure>
      ))}
    </div>
  );
}

function ArticleMaterials({ items = [] }) {
  if (!Array.isArray(items) || !items.length) return null;

  const materialLabel = (item) => {
    if (hpLang() !== 'en') return item;
    const map = {
      '3ème main': 'Helping hand tool',
      'Aiguille tordue magique faite par mes soins': 'Custom bent needle tool',
      'Alcool iso': 'Isopropyl alcohol',
      'Alcool isopropylique 99%': '99% isopropyl alcohol',
      'Boite de rangement': 'Storage box',
      'Chiffonnette à lunettes': 'Lens cloth',
      'Coton tige': 'Cotton swab',
      'Coton tiges': 'Cotton swabs',
      'Cône caoutchouc': 'Rubber cone',
      'Cônes caoutchouc': 'Rubber cones',
      'Eau oxygénée': 'Hydrogen peroxide',
      'Essence C': 'Cleaning solvent',
      'Fer à souder': 'Soldering iron',
      'Fer à souder ou station à air chaud': 'Soldering iron or hot-air station',
      'Flux': 'Flux',
      'Flux de soudure': 'Soldering flux',
      'Gants anti-statique ou bracelet anti-statique': 'Anti-static gloves or wrist strap',
      'Gants nitrile': 'Nitrile gloves',
      'Graisse Lithium': 'Lithium grease',
      'Graisse pour hélicoïde': 'Helicoid grease',
      'Huile de machine à coudre': 'Sewing machine oil',
      'Huile de vaseline': 'Vaseline oil',
      'Jeux de pinces': 'Precision pliers set',
      'Limes': 'Files',
      'Mini forets': 'Mini drill bits',
      "Mousse d'étanchéité": 'Light seal foam',
      'Multimètre': 'Multimeter',
      'Nettoyeur à ultrasons': 'Ultrasonic cleaner',
      'Papier de nettoyage optique': 'Optical cleaning paper',
      'Perceuse à main': 'Hand drill',
      'Petites limes': 'Small files',
      'Pied à coulisse': 'Caliper',
      'Pince à clamper': 'Clamp forceps',
      'Pince à clamper (toujours pratique)': 'Clamp forceps',
      'Pinceau': 'Brush',
      'Pinces de précision': 'Precision tweezers',
      'Poire soufflette': 'Air blower',
      'Poire souflette': 'Air blower',
      'Pâte à souder': 'Solder paste',
      'Spanner': 'Lens spanner',
      'Testeur de vitesses': 'Shutter speed tester',
      'Tournevis': 'Screwdrivers',
      'Tournevis à douille hexagonale de 5mm': '5mm hex socket driver',
      'Tresse à dessouder': 'Desoldering braid',
      'Ventouse pour optiques': 'Lens suction cup',
      'Ventouse à lentille': 'Lens suction cup',
      'Ventouse à optiques': 'Lens suction cup',
    };
    return map[item] || item;
  };

  return (
    <aside className="article-materials-box">
      <h2>{hpTx('Matériel utilisé', 'Tools and materials used')}</h2>
      <ul>
        {items.map((item, index) => <li key={`${item}-${index}`}>{materialLabel(item)}</li>)}
      </ul>
    </aside>
  );
}

function BlogIndex({ initialCat = null }) {
  const [cat, setCat] = React.useState(initialCat);
  const [q, setQ] = React.useState('');
  const articleCategory = (category) => {
    const map = {
      'Matériel': 'Equipment',
      'Boitier': 'Camera body',
      'Boîtier': 'Camera body',
      'Objectif': 'Lens',
      'Objectifs': 'Lenses',
      'Asahi Pentax': 'Asahi Pentax',
    };
    return hpLang() === 'en' ? (map[category] || category) : category;
  };

  const categoryCounts = VISIBLE_BLOG_ARTICLES.reduce((acc, article) => {
    const category = articleField(article, 'category') || article.category;
    acc[category] = (acc[category] || 0) + 1;
    return acc;
  }, {});
  const categories = Object.keys(categoryCounts).length
    ? Object.entries(categoryCounts).map(([label, count]) => ({ slug: label.toLowerCase(), label, count }))
    : CATEGORIES;

  const filtered = VISIBLE_BLOG_ARTICLES.filter(a => {
    const title = articleField(a, 'title');
    const excerpt = articleField(a, 'excerpt');
    const category = articleField(a, 'category') || a.category;
    if (cat && category.toLowerCase() !== cat.toLowerCase()) return false;
    if (q && !(title.toLowerCase().includes(q.toLowerCase()) || excerpt.toLowerCase().includes(q.toLowerCase()))) return false;
    return true;
  });

  return (
    <>
      <section style={{padding:'60px 0 40px', borderBottom:'1px solid var(--hair)'}}>
        <div className="container">
          <div className="kicker" style={{marginBottom:16}}>{hpTx("JOURNAL D'ATELIER · DEPUIS 2014", 'WORKSHOP JOURNAL · SINCE 2014')}</div>
          <h1 style={{fontSize:'clamp(2.35rem, 4.8vw, 4rem)', marginBottom:24, maxWidth:820}}>
            {hpLang() === 'en' ? <>Tutorials, diagnostics<br/>and documented <em style={{fontStyle:'italic', color:'var(--accent)'}}>repairs</em>.</> : <>Tutoriels, diagnostics<br/>et <em style={{fontStyle:'italic', color:'var(--accent)'}}>réparations</em> documentées.</>}
          </h1>
          <p className="lede" style={{maxWidth:640}}>
            {hpTx("Chaque boitier qui passe à l'atelier est l'occasion d'un petit récit. Voici les archives.", 'Every camera that comes through the workshop is an opportunity for a short case note. Here are the archives.')}
          </p>
        </div>
      </section>

      <section style={{padding:'32px 0', borderBottom:'1px solid var(--hair)', background:'var(--paper-2)', position:'sticky', top:90, zIndex:20}}>
        <div className="container" style={{display:'flex', gap:24, alignItems:'center', justifyContent:'space-between', flexWrap:'wrap'}}>
          <div style={{display:'flex', gap:8, flexWrap:'wrap'}}>
            <button className={`opt ${!cat ? 'active' : ''}`} onClick={() => setCat(null)}
              style={{padding:'8px 14px', fontSize:12, border:'1px solid var(--hair)', borderRadius:999, cursor:'pointer', background: !cat ? 'var(--ink)' : 'transparent', color: !cat ? 'var(--paper)' : 'var(--ink)', fontFamily:'inherit'}}>
              {hpTx('Tout', 'All')} ({VISIBLE_BLOG_ARTICLES.length})
            </button>
            {categories.map(c => {
              const active = cat === c.label;
              return (
                <button key={c.slug} className={`opt ${active ? 'active' : ''}`}
                  onClick={() => setCat(active ? null : c.label)}
                  style={{padding:'8px 14px', fontSize:12, border:'1px solid var(--hair)', borderRadius:999, cursor:'pointer', background: active ? 'var(--ink)' : 'transparent', color: active ? 'var(--paper)' : 'var(--ink)', fontFamily:'inherit'}}>
                  {articleCategory(c.label)} <span style={{opacity:0.5, marginLeft:4}}>{c.count}</span>
                </button>
              );
            })}
          </div>
          <div style={{position:'relative'}}>
            <input value={q} onChange={e=>setQ(e.target.value)} aria-label={hpTx('Rechercher un article', 'Search articles')} placeholder={hpTx('Rechercher un modèle, une panne…', 'Search a model, a fault...')}
              style={{padding:'10px 14px 10px 36px', fontSize:13, width:260, border:'1px solid var(--hair)', borderRadius:999, fontFamily:'inherit', background:'var(--paper)'}}/>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"
              style={{position:'absolute', left:14, top:'50%', transform:'translateY(-50%)', opacity:0.5}}>
              <circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>
            </svg>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="hp-grid-3 hp-article-grid" style={{gap:48, rowGap:64}}>
            {filtered.map(a => (
              <a key={a.slug} href={articleUrl(a)} data-no-spa="true" className="card-article">
                <ArticleThumb article={a} />
                <div className="meta">
                  <span className="tag">{articleCategory(articleField(a, 'category') || a.category)}</span>
                  <span>{articleField(a, 'date') || a.date}</span>
                  <span>{a.readTime}</span>
                </div>
                <h3 style={{fontSize:'1.375rem', fontWeight:500}}>{articleField(a, 'title')}</h3>
                <p style={{color:'var(--ink-soft)', fontSize:14.5, lineHeight:1.5, margin:0}}>{articleField(a, 'excerpt').slice(0, 140)}...</p>
              </a>
            ))}
          </div>
          {filtered.length === 0 && (
            <div style={{textAlign:'center', padding:'80px 0', color:'var(--muted)'}}>
              <p style={{fontFamily:'var(--font-display)', fontStyle:'italic', fontSize:24}}>{hpTx('Rien trouvé pour ces critères.', 'No post found for these filters.')}</p>
            </div>
          )}
        </div>
      </section>
    </>
  );
}

function ArticlePage({ slug }) {
  const a = BLOG_ARTICLES.find(x => (x.slug === slug || x.en?.slug === slug));
  if (!a) {
    return (
      <section className="section">
        <div className="container" style={{maxWidth:760}}>
          <h1>{hpTx('Article introuvable', 'Article not found')}</h1>
          <p className="lede">{hpTx("Cette adresse ne correspond à aucun article publié.", 'This address does not match a published article.')}</p>
          <a href={hpPath('blog')} className="btn">{hpTx('Voir tous les articles', 'Browse all posts')}</a>
        </div>
      </section>
    );
  }
  const activeCategory = articleField(a, 'category') || a.category;
  const imageCaption = articleField(a, 'imageCaption');
  const completeEnglish = hpLang() === 'en' && a.en?.contentHtml?.includes('hpml-complete-translation');
  const related = VISIBLE_BLOG_ARTICLES.filter(x => (articleField(x, 'category') || x.category) === activeCategory && x.slug !== a.slug).slice(0, 3);
  const articleCategory = (category) => {
    const map = {
      'Matériel': 'Equipment',
      'Boitier': 'Camera body',
      'Boîtier': 'Camera body',
      'Objectif': 'Lens',
      'Objectifs': 'Lenses',
      'Asahi Pentax': 'Asahi Pentax',
    };
    return hpLang() === 'en' ? (map[category] || category) : category;
  };

  return (
    <>
      <article style={{paddingTop:60, paddingBottom:80}}>
        <div className="container" style={{maxWidth:1040}}>
          <div style={{marginBottom:24}}>
            <a href={hpPath('blog')} style={{fontFamily:'var(--font-mono)', fontSize:11, letterSpacing:'0.14em', textTransform:'uppercase', color:'var(--muted)', textDecoration:'none'}}>{hpTx('· Tous les articles', '· All articles')}</a>
          </div>
          <div className="meta" style={{display:'flex', gap:16, marginBottom:20, fontFamily:'var(--font-mono)', fontSize:11, letterSpacing:'0.12em', textTransform:'uppercase', color:'var(--muted)'}}>
            <span style={{color:'var(--accent)'}}>{articleCategory(activeCategory)}</span>
            <time dateTime={a.datePublished}>{articleField(a, 'date') || a.date}</time>
            <span>{a.author?.name}</span>
            <span>{hpLang() === 'en' ? `${a.readTime} read` : `${a.readTime} de lecture`}</span>
          </div>
          <h1 style={{fontFamily:'var(--font-body)', fontSize:'clamp(2.25rem, 4.5vw, 3.5rem)', lineHeight:1.08, marginBottom:32}}>{articleField(a, 'title')}</h1>
          <p className="lede" style={{marginBottom:48}}>{articleField(a, 'excerpt')}</p>
        </div>

        <div className="container" style={{maxWidth:1040, marginBottom:56}}>
          <ArticleThumb article={a} ratio="16/9" large />
          {imageCaption && (
            <div style={{fontFamily:'var(--font-mono)', fontSize:11, color:'var(--muted)', marginTop:10, textAlign:'center'}}>
              {imageCaption}
            </div>
          )}
        </div>

        <div className="container" style={{maxWidth:920}}>
          <div className="article-content" style={{fontSize:18, lineHeight:1.7, color:'var(--ink-soft)'}}>
            {(hpLang() === 'en' && a.en?.contentHtml) ? (
              <div dangerouslySetInnerHTML={{__html: a.en.contentHtml}} />
            ) : a.contentHtml ? (
              <div dangerouslySetInnerHTML={{__html: a.contentHtml}} />
            ) : (
            <>
            <p style={{marginTop:0}}>
              Le {a.tag} est arrivé à l'atelier dans un état correct à première vue — extérieur propre, mousses vieillissantes mais fonctionnelles. C'est à l'usage que les choses se gâtent&nbsp;: la pile neuve tient à peine deux jours avant d'être vidée.
            </p>
            <p>
              Le diagnostic rapide pointe vers le bouton de test batterie. Sur ces boîtiers des années 80, le contact en sandwich de ce bouton se corrode avec le temps&nbsp;; les deux plages de cuivre finissent par ne plus se séparer complètement en position repos, laissant un courant de fuite permanent.
            </p>

            <h2 style={{fontSize:'2rem', margin:'56px 0 20px', fontWeight:500}}>Démontage</h2>
            <p>
              On commence par retirer la semelle. Quatre vis JIS (pas cruciformes&nbsp;!) et l'accès à la mécanique est direct. Le bouton de test batterie se trouve sur le flanc gauche du boitier, côté armement.
            </p>

            <div style={{margin:'40px 0'}}>
              <div className="thumb" style={{aspectRatio:'16/10', borderRadius:4, overflow:'hidden'}}>
                <div className="placeholder-img">vue détail — contact corrodé</div>
              </div>
              <div style={{fontFamily:'var(--font-mono)', fontSize:11, color:'var(--muted)', marginTop:10, textAlign:'center'}}>
                Fig. 02 — Sandwich de contact, corrosion verdâtre typique.
              </div>
            </div>

            <p>
              Un nettoyage minutieux à l'alcool isopropylique, quelques passages avec un bâtonnet abrasif fin, et l'on retrouve un cuivre brillant. Attention à ne pas déformer les lames&nbsp;: elles doivent retrouver exactement leur géométrie d'origine.
            </p>

            <blockquote style={{
              borderLeft:'3px solid var(--accent)',
              paddingLeft:24, margin:'40px 0',
              fontFamily:'var(--font-display)', fontStyle:'italic', fontSize:22, lineHeight:1.35,
              color:'var(--ink)',
            }}>
              « En argentique, 80% des pannes électroniques sont en réalité des problèmes mécaniques ou de contact. Un bon nettoyage résout l'essentiel. »
            </blockquote>

            <h2 style={{fontSize:'2rem', margin:'56px 0 20px', fontWeight:500}}>Test & remontage</h2>
            <p>
              Avant de tout refermer, on teste&nbsp;: pile neuve insérée, aiguille d'exposition réactive, valeur à vide cohérente (infinie ou très élevée). On remonte dans l'ordre inverse, sans forcer.
            </p>
            <p>
              Résultat&nbsp;: l'appareil tient désormais ses six mois de pile annoncés au catalogue. Une réparation de 20 minutes qui évite un remplacement complet.
            </p>
            </>
            )}
          </div>

          {hpLang() === 'en' && !completeEnglish && <ArticleVideos videos={a.videos} />}
          {hpLang() === 'en' && !completeEnglish && <ArticleMaterials items={a.materials} />}

          {!completeEnglish && <ElementorMediaGrid items={a.elementorMedia} />}
          <aside className="hp-author-bio"><h2>{hpTx('À propos de l’auteur', 'About the author')}</h2><p><strong>{a.author?.name}</strong> — {hpTx('Réparateur de matériel photo argentique chez HostoPhoto. L’atelier partage ses réparations et tutoriels depuis 2014.', 'Film camera repairer at HostoPhoto. The workshop has shared repairs and tutorials since 2014.')}</p><p>{hpTx('Dernière mise à jour : ', 'Last updated: ')}<time dateTime={a.dateModified}>{new Date(a.dateModified).toLocaleDateString(hpLang() === 'en' ? 'en-GB' : 'fr-FR')}</time></p></aside>

          <div style={{marginTop:72, padding:'32px 0', borderTop:'1px solid var(--hair)', borderBottom:'1px solid var(--hair)', display:'flex', gap:16, justifyContent:'space-between', alignItems:'center', flexWrap:'wrap'}}>
            <div>
              <div className="kicker" style={{marginBottom:8}}>{hpTx('VOTRE APPAREIL A LA MÊME PANNE ·', 'DOES YOUR CAMERA HAVE THE SAME ISSUE?')}</div>
              <div style={{fontFamily:'var(--font-display)', fontSize:22}}>{hpTx('Envoyez une description et quelques photos.', 'Send a description and a few photos.')}</div>
            </div>
            <a href={hpPath('devis')} className="btn">{hpTx('Demander un devis', 'Request a quote')} <span className="arrow"/></a>
          </div>
        </div>
      </article>

      <section className="section" style={{background:'var(--paper-2)'}}>
        <div className="container">
          <div className="section-title">
            <h2 style={{fontSize:'2rem'}}>{hpTx('Dans la même catégorie', 'In the same category')}</h2>
            <a href={hpPath('blog')} className="linky">{hpTx('tout le blog →', 'all posts →')}</a>
          </div>
          <div className="hp-grid-3 hp-article-grid" style={{gap:32}}>
            {related.map(r => (
              <a key={r.slug} href={articleUrl(r)} data-no-spa="true" className="card-article">
                <ArticleThumb article={r} />
                <div className="meta">
                  <span className="tag">{articleCategory(articleField(r, 'category') || r.category)}</span>
                  <span>{articleField(r, 'date') || r.date}</span>
                </div>
                <h3 style={{fontSize:'1.125rem', fontWeight:500}}>{articleField(r, 'title')}</h3>
              </a>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

Object.assign(window, { BlogIndex, ArticlePage });



/* src/services.jsx */
/* Services page */

const SERVICE_BLOCKS = PUBLIC_CONTENT.services;
const SERVICE_TRANSLATIONS_EN = PUBLIC_CONTENT.translations;

function serviceCopy(block, key) {
  if (hpLang() !== 'en') return block[key];
  return SERVICE_TRANSLATIONS_EN[block.id]?.[key] || block[key];
}

function ServicesPage() {
  return (
    <>
      {/* HERO AÉRÉ */}
      <section style={{padding:'80px 0 120px', borderBottom:'1px solid var(--hair)'}}>
        <div className="container">
          <div className="hp-services-hero">
            <div>
              <div className="kicker" style={{marginBottom:24}}>{hpTx('SERVICES · ATELIER MARSEILLE / AIX', 'SERVICES · MARSEILLE / AIX WORKSHOP')}</div>
          <h1 style={{fontSize:'clamp(2.4rem, 5vw, 4.4rem)', lineHeight:1, maxWidth:900, marginBottom:36}}>
            {hpLang() === 'en' ? (
              <>Film camera<br/><em style={{fontStyle:'italic', color:'var(--accent)'}}>repair</em>.</>
            ) : (
              <>Réparation<br/><em style={{fontStyle:'italic', color:'var(--accent)'}}>photo argentique</em>.</>
            )}
          </h1>
          <p className="lede" style={{maxWidth:720}}>
            {hpTx(
              "Quatre familles d'interventions — boîtiers, objectifs, accessoires, personnalisation. Pour chacune, la même approche : diagnostic franc, travail méticuleux, garantie un an.",
              'Four families of work: camera bodies, lenses, accessories and customization. The same approach every time: honest diagnosis, careful work and one-year warranty.'
            )}
          </p>
            </div>
            <figure className="hp-services-hero-media">
              <img src={themeAsset('assets/services-hero-solenoid.webp')} alt={hpTx('Petite pièce de boîtier argentique tenue à la pince', 'Small film camera part held with tweezers')} decoding="async" fetchPriority="high" />
            </figure>
          </div>
          <div style={{display:'flex', gap:32, marginTop:56, flexWrap:'wrap', fontFamily:'var(--font-mono)', fontSize:11, letterSpacing:'0.14em', textTransform:'uppercase', color:'var(--muted)'}}>
            {SERVICE_BLOCKS.map(b => (
              <a key={b.id} href={`#services-${b.id}`}
                 onClick={(e) => { e.preventDefault(); document.getElementById(`services-${b.id}`)?.scrollIntoView({ behavior:'smooth' }); }}
                 style={{color:'var(--ink)', textDecoration:'none', display:'flex', gap:8, alignItems:'baseline'}}>
                <span style={{color:'var(--accent)'}}>{b.num}</span>
                <span>{serviceCopy(b, 'title')}</span>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* BLOCS SERVICES PLEINE LARGEUR */}
      {SERVICE_BLOCKS.map((b, idx) => (
        <React.Fragment key={b.id}>
        <section id={`services-${b.id}`} style={{padding:'72px 0'}}>
          <div className="container">
            <div className={`hp-split hp-service-detail ${idx % 2 === 0 ? '' : 'hp-service-detail-reverse'}`} style={{
              alignItems:'center',
            }}>
              <div style={{order: idx % 2 === 0 ? 1 : 2}}>
                <div style={{fontFamily:'var(--font-mono)', fontSize:72, fontWeight:400, color:'var(--accent)', lineHeight:1, marginBottom:24}}>{b.num}</div>
                <h2 style={{fontSize:'clamp(2.5rem, 5vw, 4rem)', lineHeight:1, marginBottom:28}}>{serviceCopy(b, 'title')}</h2>
                <p className="lede" style={{fontSize:'1.5rem', marginBottom:32, maxWidth:560}}>{serviceCopy(b, 'lede')}</p>
                {serviceCopy(b, 'body').map((p, i) => (
                  <p key={i} style={{fontSize:17, lineHeight:1.7, color:'var(--ink-soft)', marginBottom:20, maxWidth:540}}>{p}</p>
                ))}
                <div className="hp-grid-2 hp-pill-grid" style={{gap:12, marginTop:36, maxWidth:520}}>
                  {serviceCopy(b, 'bullets').map(bt => (
                    <div key={bt} style={{
                      padding:'14px 18px', border:'1px solid var(--hair)', borderRadius:999,
                      fontFamily:'var(--font-mono)', fontSize:11, letterSpacing:'0.12em', textTransform:'uppercase',
                      display:'flex', gap:10, alignItems:'center',
                    }}>
                      <span style={{width:6, height:6, borderRadius:'50%', background:'var(--accent)'}}/>
                      {bt}
                    </div>
                  ))}
                </div>
                <div style={{marginTop:40, display:'flex', gap:16, alignItems:'center', flexWrap:'wrap'}}>
                  <a href={hpPath('devis')} className="btn">{hpTx('Demander un devis', 'Request a quote')} <span className="arrow"/></a>
                  <a href={hpPath('faq')} className="linky">{hpTx('voir la FAQ →', 'read the FAQ →')}</a>
                </div>
              </div>

              <div style={{order: idx % 2 === 0 ? 2 : 1, position:'relative'}}>
                {b.image === 'rollei' ? (
                  <div style={{padding:'24px 0', borderRadius:8, display:'flex', justifyContent:'center', alignItems:'center', minHeight:560, position:'relative', overflow:'hidden'}}>
                    <img src={themeAsset('assets/rollei-reparation-boitier.webp')} alt={serviceCopy(b, 'imageLabel')}
                         loading="lazy" decoding="async"
                         style={{width:'100%', maxWidth:760, height:'auto', display:'block'}}/>
                  </div>
                ) : b.image === 'objectif' ? (
                  <div style={{padding:'12px 0', borderRadius:8, display:'flex', justifyContent:'center', alignItems:'center', minHeight:640, position:'relative', overflow:'hidden'}}>
                    <img src={themeAsset('assets/objectif-reparation.webp')} alt={serviceCopy(b, 'imageLabel')}
                         loading="lazy" decoding="async"
                         style={{maxHeight:780, width:'auto', maxWidth:'100%', display:'block'}}/>
                  </div>
                ) : b.image === 'compur2' ? (
                  <div style={{padding:'12px 0', borderRadius:8, display:'flex', justifyContent:'center', alignItems:'center', minHeight:640, position:'relative', overflow:'hidden'}}>
                    <ScrollAnimatedImage src={themeAsset('assets/compur2-3D.webp')} alt={serviceCopy(b, 'imageLabel')} maxHeight="720px"/>
                  </div>
                ) : b.image === 'personnalisation' ? (
                  <div style={{padding:'12px 0', borderRadius:8, display:'flex', justifyContent:'center', alignItems:'center', minHeight:640, position:'relative', overflow:'hidden'}}>
                    <img src={themeAsset('assets/personnalisation-rolleiflex.webp')} alt={serviceCopy(b, 'imageLabel')}
                         loading="lazy" decoding="async"
                         style={{maxHeight:780, width:'auto', maxWidth:'100%', display:'block'}}/>
                  </div>
                ) : (
                  <div style={{aspectRatio:'4/5', background:'var(--ink)', borderRadius:8, position:'relative', overflow:'hidden'}}>
                    <div className="placeholder-img" style={{background:'transparent'}}>{b.imageLabel.toLowerCase()}</div>
                    <div style={{position:'absolute', bottom:24, left:24, fontFamily:'var(--font-mono)', fontSize:10, letterSpacing:'0.14em', textTransform:'uppercase', color:'rgba(244,239,230,0.6)'}}>{b.imageLabel}</div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="container" style={{marginTop:72}}>
            <div style={{borderTop:'1px solid var(--hair)'}}/>
          </div>
        </section>

        {/* IMAGE PARALLAX INTERCALAIRE (après le bloc 01 uniquement) */}
        {idx === 0 && <ParallaxPlate />}
        </React.Fragment>
      ))}

      {/* Ancien gabarit cartes 03/04 désactivé : les quatre services utilisent maintenant le bloc pleine largeur. */}
      {false && <section>
        <div className="container">
          <div className="hp-grid-2 hp-service-card-grid" style={{gap:48}}>
            {SERVICE_BLOCKS.slice(2, 4).map(b => (
              <div key={b.id} id={`services-${b.id}`} style={{display:'flex', flexDirection:'column'}}>
                <div style={{fontFamily:'var(--font-mono)', fontSize:56, fontWeight:400, color:'var(--accent)', lineHeight:1, marginBottom:20}}>{b.num}</div>
                <h2 style={{fontSize:'clamp(2rem, 3.5vw, 3rem)', lineHeight:1.05, marginBottom:20}}>{b.title}</h2>
                <p className="lede" style={{fontSize:'1.25rem', marginBottom:24}}>{b.lede}</p>
                {!b.image ? null : b.image === 'compur2' ? (
                  <div style={{aspectRatio:'4/3', background:'var(--ink)', borderRadius:8, position:'relative', overflow:'hidden', margin:'8px 0 32px', display:'flex', justifyContent:'center', alignItems:'center', padding:'28px 24px'}}>
                    <ScrollAnimatedImage src={themeAsset('assets/compur2-3D.webp')} alt="Obturateur central, vue éclatée"/>
                    <div style={{position:'absolute', bottom:18, left:18, fontFamily:'var(--font-mono)', fontSize:10, letterSpacing:'0.14em', textTransform:'uppercase', color:'rgba(244,239,230,0.6)'}}>{b.imageLabel}</div>
                  </div>
                ) : b.image === 'personnalisation' ? (
                  <div style={{aspectRatio:'4/3', background:'var(--ink)', borderRadius:8, position:'relative', overflow:'hidden', margin:'8px 0 32px', display:'flex', justifyContent:'center', alignItems:'center', padding:'0'}}>
                    <img src={themeAsset('assets/personnalisation-rolleiflex.webp')} alt="Rolleiflex personnalisé avec habillage rouge"
                         loading="lazy" decoding="async"
                         style={{width:'100%', height:'100%', objectFit:'cover', objectPosition:'center', display:'block'}}/>
                    <div style={{position:'absolute', bottom:18, left:18, fontFamily:'var(--font-mono)', fontSize:10, letterSpacing:'0.14em', textTransform:'uppercase', color:'rgba(244,239,230,0.72)'}}>{b.imageLabel}</div>
                  </div>
                ) : null}
                {b.body.map((p, i) => (
                  <p key={i} style={{fontSize:15.5, lineHeight:1.65, color:'var(--ink-soft)', marginBottom:16}}>{p}</p>
                ))}
                <div className="hp-grid-2 hp-pill-grid" style={{gap:10, marginTop:24}}>
                  {b.bullets.map(bt => (
                    <div key={bt} style={{
                      padding:'10px 14px', border:'1px solid var(--hair)', borderRadius:999,
                      fontFamily:'var(--font-mono)', fontSize:10.5, letterSpacing:'0.1em', textTransform:'uppercase',
                      display:'flex', gap:8, alignItems:'center',
                    }}>
                      <span style={{width:5, height:5, borderRadius:'50%', background:'var(--accent)', flexShrink:0}}/>
                      {bt}
                    </div>
                  ))}
                </div>
                <div style={{marginTop:'auto', paddingTop:36, display:'flex', gap:16, alignItems:'center'}}>
                  <a href={hpPath('devis')} className="btn">{hpTx('Demander un devis', 'Request a quote')} <span className="arrow"/></a>
                  <a href={hpPath('faq')} className="linky">{'FAQ \u2192'}</a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>}

      {/* CITATION PLEINE PAGE */}
      <section style={{padding:'140px 0', background:'var(--paper-2)'}}>
        <div className="container" style={{maxWidth:960, textAlign:'center'}}>
          <div className="kicker" style={{marginBottom:32}}>{hpTx("PRINCIPE D'ATELIER", 'WORKSHOP PRINCIPLE')}</div>
          <blockquote style={{fontFamily:'var(--font-display)', fontSize:'clamp(1.75rem, 4vw, 3rem)', lineHeight:1.2, fontStyle:'italic', margin:0, color:'var(--ink)', textWrap:'balance'}}>
            {hpLang() === 'en'
              ? 'With film cameras, many so-called electronic faults are actually mechanical or contact problems. Careful cleaning solves a surprising amount.'
              : "En argentique, 80 % des pannes dites électroniques sont en réalité des problèmes mécaniques ou de contact. Un bon nettoyage résout l'essentiel."}
          </blockquote>
          <div style={{marginTop:40, fontFamily:'var(--font-mono)', fontSize:11, letterSpacing:'0.14em', textTransform:'uppercase', color:'var(--muted)'}}>· HostoPhoto</div>
        </div>
      </section>

      {/* FAQ LINK + RACHAT */}
      <section style={{padding:'100px 0 120px'}}>
        <div className="container">
          <div className="hp-grid-2 hp-cta-grid" style={{gap:32}}>
            <a href={hpPath('faq')} style={{display:'block', padding:'48px', background:'var(--ink)', color:'var(--paper)', borderRadius:8, textDecoration:'none', position:'relative', overflow:'hidden'}}>
              <div style={{fontFamily:'var(--font-mono)', fontSize:11, letterSpacing:'0.18em', color:'var(--highlight)', marginBottom:20}}>{hpTx('FAQ ATELIER', 'WORKSHOP FAQ')}</div>
              <h3 style={{color:'var(--paper)', fontSize:'2rem', marginBottom:16, fontWeight:500}}>{hpLang() === 'en' ? <>Clear answers<br/>before sending.</> : <>Questions fréquentes,<br/>réponses claires.</>}</h3>
              <p style={{opacity:0.8, fontSize:15, lineHeight:1.55, margin:'0 0 32px', maxWidth:380}}>{hpTx("Fonctionnement de l'atelier, délais, devis, envoi du matériel, garantie et prix indicatifs.", 'How the workshop works, timing, quotes, shipping, warranty and indicative prices.')}</p>
              <span className="btn accent">{hpTx('Consulter la FAQ', 'Read the FAQ')} <span className="arrow"/></span>
            </a>
            <a href={hpPath('contact')} style={{display:'block', padding:'48px', background:'var(--paper-2)', color:'var(--ink)', borderRadius:8, textDecoration:'none', border:'1px solid var(--hair)'}}>
              <div className="kicker" style={{marginBottom:20, color:'var(--accent)'}}>{hpTx('RACHAT DE MATÉRIEL', 'BUYING EQUIPMENT')}</div>
              <h3 style={{fontSize:'2rem', marginBottom:16, fontWeight:500}}>{hpLang() === 'en' ? <>I also buy<br/>film gear.</> : <>Je rachète<br/>vos argentiques.</>}</h3>
              <p style={{color:'var(--ink-soft)', fontSize:15, lineHeight:1.55, margin:'0 0 32px', maxWidth:380}}>{hpTx('Boîtiers, objectifs, collections entières — en état ou à restaurer. Offre ferme sous 72h.', 'Camera bodies, lenses and full collections, working or for restoration. Firm offer within 72 hours.')}</p>
              <span className="btn">{hpTx('Proposer du matériel', 'Offer equipment')} <span className="arrow"/></span>
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

Object.assign(window, { ServicesPage });

function ScrollAnimatedImage({ src, alt, maxHeight = '100%' }) {
  const ref = React.useRef(null);
  const [t, setT] = React.useState(0); // 0 = hors champ, 1 = pleinement visible

  React.useEffect(() => {
    let raf = 0;
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        const el = ref.current;
        if (!el) return;
        const rect = el.getBoundingClientRect();
        const vh = window.innerHeight;
        // 0 quand le sommet est au bas du viewport, 1 quand il est ? 40% du haut
        const p = (vh - rect.top) / (vh * 0.75);
        setT(Math.max(0, Math.min(1, p)));
      });
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  // Easing out
  const e = 1 - Math.pow(1 - t, 3);
  const rotation = -20 + e * 20;    // -20? ? 0?
  const scale = 0.82 + e * 0.18;    // 0.82 ? 1
  const opacity = e;
  const translateY = (1 - e) * 40;  // 40px ? 0

  return (
    <img
      ref={ref}
      src={src}
      alt={alt}
      loading="lazy"
      decoding="async"
      style={{
        maxHeight, maxWidth:'100%', width:'auto',
        filter:'drop-shadow(0 20px 40px rgba(0,0,0,0.6))',
        transform: `translate3d(0, ${translateY}px, 0) rotate(${rotation}deg) scale(${scale})`,
        opacity,
        transition: 'none',
        willChange: 'transform, opacity',
      }}
    />
  );
}

function ParallaxPlate() {
  const ref = React.useRef(null);
  const [offset, setOffset] = React.useState(0);
  const [blend, setBlend] = React.useState(0); // 0 = N&B, 1 = 3D

  React.useEffect(() => {
    let raf = 0;
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        const el = ref.current;
        if (!el) return;
        const rect = el.getBoundingClientRect();
        const vh = window.innerHeight;
        // progress for parallax: -1 (under) ? 0 (centered) ? 1 (above)
        const progress = (rect.top + rect.height / 2 - vh / 2) / (vh + rect.height / 2);
        setOffset(progress * -80);
        // blend 0?1 ? transition rapide autour du centre de la section
        // progress = -0.1 ? blend 0 ; progress = +0.2 ? blend 1
        const raw = (progress + 0.1) / 0.3;
        setBlend(Math.max(0, Math.min(1, raw)));
      });
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  const imgStyle = {
    width: 'min(1200px, 90%)',
    maxHeight: '72%',
    height: 'auto',
    objectFit: 'contain',
    position: 'absolute',
    top: '50%', left: '50%',
    transform: 'translate(-50%, -50%)',
  };

  return (
    <section ref={ref} style={{
      position:'relative',
      height: 'clamp(640px, 95vh, 920px)',
      overflow: 'hidden',
      margin: '40px 0 80px',
    }}>
      {/* parallax image layer */}
      <div style={{
        position:'absolute', inset: 0,
        transform: `translate3d(0, ${offset}px, 0)`,
        willChange: 'transform',
      }}>
        {/* N&B — visible en début */}
        <img src={themeAsset('assets/500cm-bw.png')} alt={hpTx("Vue éclatée d'un Hasselblad 500CM (trait)", 'Exploded Hasselblad 500CM view (line art)')}
             loading="lazy" decoding="async"
             style={{...imgStyle, opacity: (1 - blend) * 0.55}}/>
        {/* 3D — apparaît au scroll */}
        <img src={themeAsset('assets/500cm-3d.png')} alt={hpTx("Vue éclatée d'un Hasselblad 500CM (rendu 3D)", 'Exploded Hasselblad 500CM view (3D render)')}
             loading="lazy" decoding="async"
             style={{...imgStyle, opacity: blend}}/>
      </div>

      {/* editorial text overlay */}
      <div className="container" style={{
        position:'relative', height:'100%',
        display:'flex', flexDirection:'column', justifyContent:'space-between',
        pointerEvents:'none',
      }}>
        <div style={{
          fontFamily:'var(--font-mono)', fontSize:11, letterSpacing:'0.18em', textTransform:'uppercase',
          color:'var(--muted)', paddingTop:24,
        }}>
          {hpTx('PL. 01 — HASSELBLAD 500CM', 'PL. 01 — HASSELBLAD 500CM')} <span style={{opacity:0.5}}>{hpTx('· vue éclatée', '· exploded view')}</span>
        </div>
        <div style={{
          display:'flex', justifyContent:'space-between', alignItems:'flex-end',
          paddingBottom:24, gap:40,
        }}>
          <div style={{
            fontFamily:'var(--font-display)', fontStyle:'italic',
            fontSize:'clamp(1.5rem, 3vw, 2.5rem)', lineHeight:1.15,
            maxWidth:560, color:'var(--ink)', textWrap:'balance',
          }}>
            {hpTx("« Un boîtier, c'est d'abord une somme de petites pièces qui veulent bien travailler ensemble. »", '“A camera body is first a collection of small parts willing to work together.”')}
          </div>
          <div style={{
            fontFamily:'var(--font-mono)', fontSize:11, letterSpacing:'0.16em', textTransform:'uppercase',
            color:'var(--muted)', textAlign:'right', whiteSpace:'nowrap',
          }}>
            {'Fig. A'}<br/>{hpTx('moyen format — 6×6', 'medium format — 6×6')}
          </div>
        </div>
      </div>
    </section>
  );
}




/* src/tarifs.jsx */
﻿/* Tarifs page */

const TARIFS_CATS = [
  {
    id: 'boitiers', label: 'Bo\u00eetiers',
    intro: "Reflex 35mm, TLR moyen format, t\u00e9l\u00e9m\u00e9triques, compacts m\u00e9caniques.",
    services: [
      { name: 'Diagnostic complet', price: 'Gratuit sur place', note: '45 min env.', desc: "Inspection visuelle, test des vitesses au banc, cellule, obturateur, retour honn\u00eate." },
      { name: 'Nettoyage & lubrification', price: 'd\u00e8s 120\u20ac', note: '1 \u00e0 2 sem.', desc: "CLA \u2014 Clean, Lubricate, Adjust. La r\u00e9vision d'entretien de base pour un bo\u00eetier qui tourne depuis 40 ans." },
      { name: 'Remplacement mousses', price: 'd\u00e8s 60\u20ac', note: '3-5 jours', desc: "Joints de dos, amortisseur de miroir, chambre noire. Mousses neuves coup\u00e9es sur mesure." },
      { name: 'R\u00e9paration obturateur', price: 'd\u00e8s 180\u20ac', note: '2 \u00e0 3 sem.', desc: "Rideaux coll\u00e9s, vitesses lentes, synchro flash. D\u00e9montage et remise en \u00e9tat du groupe obturateur." },
      { name: 'Calibration cellule', price: 'd\u00e8s 90\u20ac', note: '1 sem.', desc: "Ajustement de la cellule CdS ou S\u00e9l\u00e9nium, remplacement si n\u00e9cessaire." },
    ],
  },
  {
    id: 'objectifs', label: 'Objectifs',
    intro: "Démontage et nettoyage intérieur, diaphragme, hélicoïde, bague de mise au point.",
    services: [
      { name: 'Nettoyage des lentilles', price: 'dès 80€', note: '1 sem.', desc: "Poussières, buée, traces de doigt — on ouvre, on nettoie, on remonte aligné." },
      { name: 'Traitement des champignons', price: 'dès 140€', note: '2 sem.', desc: "Intervention chirurgicale : les champignons attaquent le traitement des lentilles, il faut les déloger sans dégrader le coating." },
      { name: 'Réparation du diaphragme', price: 'dès 110€', note: '1-2 sem.', desc: "Lamelles bloquées, traces d'huile, bague qui ne tient plus les crans." },
      { name: 'Dégraissage de l\'hélicoïde', price: 'dès 95€', note: '1 sem.', desc: "Pour les objectifs dont la bague de mise au point est dure, ou au contraire molle." },
    ],
  },
  {
    id: 'peripheriques', label: 'Cellules & accessoires',
    intro: "Cellules main, flashs anciens, dos, posemètres.",
    services: [
      { name: 'Révision cellule main', price: 'dès 70€', note: '1 sem.', desc: "Weston, Sekonic, Gossen — nettoyage, calibration, remplacement cellule si besoin." },
      { name: 'Flash cobra ancien', price: 'sur devis', note: '2 sem.', desc: "Condensateurs secs, contacts corrodés. Remise en service avec contrôle sécurité." },
      { name: 'Dos interchangeable', price: 'dès 60€', note: '1 sem.', desc: "Étanchéité, compteur, sécurité de verrouillage pour dos Hasselblad, Mamiya…" },
    ],
  },
];

const TARIFS_BRANDS = PUBLIC_CONTENT.brands;

function TarifsPage() {
  const faqItems = PUBLIC_CONTENT.faq[hpLang()] || PUBLIC_CONTENT.faq.fr;
  return (
    <>
      <section style={{padding:'60px 0 40px', borderBottom:'1px solid var(--hair)'}}>
        <div className="container">
          <div className="kicker" style={{marginBottom:16}}>{hpTx('FAQ · ATELIER · DEVIS SUR DEMANDE', 'FAQ · WORKSHOP · QUOTES ON REQUEST')}</div>
          <div className="hp-split hp-split-hero" style={{alignItems:'end'}}>
            <h1 style={{fontSize:'clamp(3rem, 6.5vw, 5.5rem)', lineHeight:0.95}}>
              {hpLang() === 'en' ? 'Frequently asked' : 'Questions'}<br/>
              <em style={{fontStyle:'italic', color:'var(--accent)'}}>{hpLang() === 'en' ? 'questions' : 'fréquentes'}</em>.
            </h1>
            <p className="lede" style={{maxWidth:440}}>
              {hpTx("Fonctionnement de l'atelier, délais, devis, envoi du matériel et garantie. Les prix restent indicatifs : chaque devis est calculé sur mesure après diagnostic.", 'How the workshop works, timing, quotes, shipping and warranty. Prices remain indicative: every quote is calculated after diagnosis.')}
            </p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="hp-split hp-split-feature" style={{alignItems:'start'}}>
            <div>
              <div className="kicker" style={{marginBottom:14}}>{hpTx('MARQUES TRAITÉES', 'BRANDS I WORK ON')}</div>
              <h2 style={{fontSize:'2.25rem', marginBottom:20, fontWeight:500}}>{hpTx('La plupart des fabricants argentiques, français, japonais ou allemands.', 'Most French, Japanese and German film camera manufacturers.')}</h2>
              <p style={{color:'var(--ink-soft)', fontSize:16, lineHeight:1.55}}>{hpTx("La liste n'est pas exhaustive et je ne sais pas tout faire :). Si votre matériel n'y figure pas, posez tout de même la question — je peux sûrement vous recommander un atelier partenaire qui pourra vous aider.", "The list is not exhaustive, and I do not repair absolutely everything :). If your equipment is not listed, still ask — I may be able to recommend a partner workshop that can help.")}</p>
            </div>
            <div className="hp-grid-3 hp-brand-grid" style={{border:'1px solid var(--hair)', borderRadius:4, overflow:'hidden'}}>
              {TARIFS_BRANDS.map((b, i) => (
                <div key={b} style={{
                  padding:'20px 18px',
                  borderRight: (i % 3 !== 2) ? '1px solid var(--hair)' : 'none',
                  borderBottom: i < TARIFS_BRANDS.length - 3 ? '1px solid var(--hair)' : 'none',
                  fontFamily:'var(--font-display)', fontSize:'1.125rem',
                  display:'flex', alignItems:'center', gap:10,
                }}>
                  <span style={{fontFamily:'var(--font-mono)', fontSize:10, color:'var(--muted)', minWidth:28}}>
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <span>{b}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="section" style={{paddingTop:0}}>
        <div className="container" style={{maxWidth:920}}>
          <div className="section-title">
            <h2 style={{fontSize:'2.25rem'}}>{hpTx('Questions fréquentes', 'Frequently asked questions')}</h2>
            <a href={hpPath('contact')} className="linky">{hpTx('une autre question \u2192', 'another question \u2192')}</a>
          </div>
          {faqItems.map(([q, a], i) => <Faq key={i} q={q} a={a}/>)}
        </div>
      </section>
    </>
  );
}

function Faq({ q, a }) {
  return <details className="hp-faq-item">
    <summary>{q}</summary><div>{a}</div>
  </details>;
}

Object.assign(window, { TarifsPage });



/* src/devis.jsx */
/* Devis page : intro éditoriale + timeline du process + accès client + formulaire multi-étapes */

const PROCESS_STEPS = [
  {
    n: '01',
    title: 'Demande de devis',
    short: 'Vous remplissez le formulaire',
    body: "Vous décrivez le matériel à envoyer et le problème observé. Plus c'est précis, plus la première réponse est utile. Si des photos sont nécessaires, elles vous seront demandées ensuite par email.",
    imageLabel: "FORMULAIRE EN COURS DE SAISIE",
    image: 'quote-step-01-form.webp',
    duration: 'env. 5 min',
  },
  {
    n: '02',
    title: 'Réponse à la demande',
    short: 'Acceptation ou refus sous 48h',
    body: "Je vous réponds sous 48h pour accepter ou refuser la prise en charge. Si la demande est acceptée, vous recevez l'adresse d'envoi avec quelques conseils d'emballage.",
    imageLabel: "ÉTIQUETTE D'EXPÉDITION & EMBALLAGE",
    image: 'quote-step-02-reply-shipping.webp',
    duration: 'sous 48h',
  },
  {
    n: '03',
    title: 'Réception à l\'atelier',
    short: 'Votre colis arrive chez moi',
    body: "Vous êtes notifié de la réception de votre matériel à l'atelier. Le matériel entre ensuite dans la file d'attente avant diagnostic ; en période chargée, ce délai peut atteindre plusieurs semaines.",
    imageLabel: "BOITIER REÇU, DÉBALLAGE ATELIER",
    image: 'quote-step-03-received.webp',
    duration: 'à réception',
  },
  {
    n: '04',
    title: 'Diagnostic & devis',
    short: 'Inspection quand son tour arrive',
    body: "Dès que votre matériel passe en diagnostic, vous recevez un devis chiffré par email ou dans votre espace client. Vous l'acceptez ou le refusez — sans frais en cas de refus.",
    imageLabel: "DIAGNOSTIC SOUS LOUPE BINOCULAIRE",
    image: 'quote-step-04-diagnostic.webp',
    duration: 'selon file',
  },
  {
    n: '05',
    title: 'Réparation & retour',
    short: 'Paiement, et il rentre',
    body: "Une fois la réparation effectuée, vous recevez une confirmation et un lien de paiement. Vous confirmez l'adresse de retour, et votre matériel vous revient en bonne santé.",
    imageLabel: "BOITIER EMBALLÉ POUR LE RETOUR",
    image: 'quote-step-05-return-payment.webp',
    duration: '2 à 6 semaines',
  },
];

function ProcessTimeline() {
  const steps = hpLang() === 'en'
    ? [
      { ...PROCESS_STEPS[0], title: 'Quote request', short: 'You fill in the form', body: 'Describe the equipment and the problem you noticed. The more precise it is, the more useful the first reply can be.', imageLabel: 'FORM BEING FILLED IN', duration: 'about 5 min' },
      { ...PROCESS_STEPS[1], title: 'Initial reply', short: 'Accepted or refused within 48h', body: 'I reply within 48 hours to accept or refuse the intake request. If it is accepted, you receive the shipping address and packing advice.', imageLabel: 'SHIPPING INSTRUCTIONS', duration: 'within 48h' },
      { ...PROCESS_STEPS[2], title: 'Arrival at the workshop', short: 'Your parcel reaches me', body: 'You are notified when the equipment arrives at the workshop. It then enters the queue before diagnosis; in busy periods this can take several weeks.', imageLabel: 'CAMERA RECEIVED AT THE WORKSHOP', duration: 'on arrival' },
      { ...PROCESS_STEPS[3], title: 'Diagnosis & quote', short: 'Inspection when its turn comes', body: 'When your equipment is diagnosed, you receive a priced quote by email or in your customer account. You can accept or refuse it.', imageLabel: 'DIAGNOSIS UNDER MAGNIFICATION', duration: 'queue based' },
      { ...PROCESS_STEPS[4], title: 'Repair & return', short: 'Payment, then return', body: 'Once the repair is complete, you receive a confirmation and payment link. You confirm the return address, and the equipment comes back ready to use.', imageLabel: 'CAMERA PACKED FOR RETURN', duration: '2 to 6 weeks' },
    ]
    : PROCESS_STEPS;
  return (
    <section style={{padding:'40px 0 80px'}}>
      <div className="container">
        <div className="kicker" style={{marginBottom:16}}>{hpTx('FRISE — DE LA DEMANDE AU RETOUR', 'TIMELINE — FROM REQUEST TO RETURN')}</div>
        <h2 style={{fontSize:'clamp(2rem, 4vw, 3.25rem)', maxWidth:880, marginBottom:20, fontWeight:500}}>
          {hpTx('Comment se déroule la prise en charge de votre matériel.', 'How your equipment is handled, step by step.')}
        </h2>
        <p className="lede" style={{maxWidth:720, marginBottom:64}}>
          {hpTx("Cinq étapes, du formulaire jusqu'au retour de votre boitier réparé. Chaque transition vous est notifiée par email — ou dans votre espace client si vous en avez un.", 'Five steps, from the form to the return of your repaired camera. Each transition is notified by email, or in your customer account if you have one.')}
        </p>

        <div className="timeline">
          {/* axe vertical central */}
          <div className="timeline-axis" aria-hidden="true">
            <span className="axis-cap top"/>
            <span className="axis-cap bot"/>
          </div>

          {steps.map((s, i) => {
            const side = i % 2 === 0 ? 'right' : 'left';
            return (
              <div key={s.n} className={`tl-row tl-${side}`}>
                {/* MÉDIA — côté A */}
                <div className="tl-side tl-media-side">
                  <div className="timeline-media" aria-label={s.imageLabel}>
                    <img
                      className="process-stock-pixel-img"
                      src={`${window.HOSTOPHOTO_THEME_URI || ''}/assets/quote-process/${s.image}?v=16bit-landscape-final-20260517`}
                      alt={s.imageLabel}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>

                {/* MARQUEUR au centre — pastille avec numéro qui croise l'axe */}
                <div className="tl-marker">
                  <span className="tl-dot"/>
                  <span className="tl-pill">
                    <span className="tl-pill-n">{s.n}</span>
                    <span className="tl-pill-d">{s.duration}</span>
                  </span>
                </div>

                {/* TEXTE — côté B */}
                <div className="tl-side tl-text-side">
                  <div className="tl-card">
                    <h3 className="timeline-title">{s.title}</h3>
                    <p className="timeline-short">{s.short}</p>
                    <p className="timeline-body">{s.body}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

function ClientAccessStrip() {
  const isLoggedIn = Boolean(window.HOSTOPHOTO_QUOTE_API?.isLoggedIn);

  if (isLoggedIn) {
    return null;
  }

  return (
    <section style={{padding:'0 0 80px'}}>
      <div className="container">
        <a href={hpPath('compte')} className="client-strip">
          <div className="client-strip-icon" aria-hidden="true">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <circle cx="12" cy="8" r="4"/>
              <path d="M4 20c0-4 4-6 8-6s8 2 8 6"/>
            </svg>
          </div>
          <div style={{flex:1, minWidth:0}}>
            <div className="kicker" style={{marginBottom:6}}>{hpTx('VOUS AVEZ DÉJÀ UN COMPTE ?', 'ALREADY HAVE AN ACCOUNT?')}</div>
            <h3 style={{fontSize:'clamp(1.4rem, 2.5vw, 1.9rem)', fontWeight:500, marginBottom:6}}>
              {hpLang() === 'en' ? <>Sign in to your <em style={{fontStyle:'italic', color:'var(--accent)'}}>customer account</em>.</> : <>Connectez-vous à votre <em style={{fontStyle:'italic', color:'var(--accent)'}}>espace client</em>.</>}
            </h3>
            <p style={{fontSize:14.5, color:'var(--ink-soft)', maxWidth:560, margin:0, lineHeight:1.55}}>
              {hpTx("Suivez l'avancement de vos demandes en cours, retrouvez vos devis, factures et l'historique de vos interventions.", 'Track ongoing requests, quotes, invoices, orders and repair history.')}
            </p>
          </div>
          <span className="btn ghost" style={{whiteSpace:'nowrap'}}>{hpTx('Se connecter', 'Sign in')} <span className="arrow"/></span>
        </a>
      </div>
    </section>
  );
}

function DevisPage() {
  const [step, setStep] = React.useState(0);
  const [data, setData] = React.useState({});
  const [submitted, setSubmitted] = React.useState(false);
  const [submitError, setSubmitError] = React.useState('');
  const [submitResult, setSubmitResult] = React.useState(null);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const quoteSteps = hpLang() === 'en'
    ? [
      { ...DEVIS_STEPS[0], title: 'Your equipment', question: 'What equipment is it?', hint: 'Several choices possible.', options: ['35mm SLR camera', 'TLR / medium format twin-lens', 'Rangefinder', 'Lens', 'Leaf shutter', 'Other'] },
      { ...DEVIS_STEPS[1], title: 'Brand(s) & model(s)', question: 'Can you specify the brand(s) and model(s)?', placeholder: 'e.g. Canon A1, Yashica Mat 124G...' },
      { ...DEVIS_STEPS[2], title: 'Symptoms', question: 'Describe the symptoms you noticed', placeholder: 'Stuck shutter, meter showing strange values, unusual noise, mirror staying up...' },
      { ...DEVIS_STEPS[3], title: 'Priority handling', question: 'Would you like to request faster priority handling?', hint: 'This option does not guarantee an immediate quote: it flags the request as priority if the workshop queue allows it.', options: ['No, standard handling', 'Yes, I would like priority handling'] },
      { ...DEVIS_STEPS[4], title: 'Your contact details', question: 'So I can reply to your request' },
    ]
    : DEVIS_STEPS;

  const setField = (id, v) => setData({ ...data, [id]: v });
  const next = () => step < quoteSteps.length - 1 ? setStep(step + 1) : submitQuoteRequest();
  const prev = () => setStep(Math.max(0, step - 1));

  const current = quoteSteps[step];
  const progress = (step + 1) / quoteSteps.length;
  const selectedMateriels = Array.isArray(data.materiel) ? data.materiel : [];
  const hasOtherMateriel = Array.isArray(data.materiel)
    && data.materiel.some(v => v.startsWith('Autre'));

  if (submitted) {
    return (
      <section style={{padding:'120px 0', minHeight:'60vh'}}>
        <div className="container" style={{maxWidth:640, textAlign:'center'}}>
          <div style={{
            width:80, height:80, margin:'0 auto 32px', borderRadius:'50%',
            border:'2px solid var(--accent)', display:'grid', placeItems:'center',
          }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="2.5">
              <path d="M5 12l5 5 10-12"/>
            </svg>
          </div>
          <h1 style={{fontSize:'3rem', marginBottom:20}}>{hpTx('Demande reçue.', 'Request received.')}</h1>
          <p className="lede" style={{marginBottom:32}}>
            {hpTx('Votre demande a bien été transmise. Je vous réponds sous 48 heures pour accepter ou refuser la prise en charge. Le devis chiffré sera établi plus tard, après réception et passage du matériel en diagnostic. Une confirmation vient d’être envoyée à', 'Your request has been submitted. I will reply within 48 hours to accept or refuse the intake. The priced quote will be prepared later, after reception and diagnosis. A confirmation has been sent to')} <strong>{data.contact?.email || hpTx('votre adresse', 'your address')}</strong>.
          </p>
          {submitResult?.sync_status === 'failed' && (
            <p style={{fontSize:14, color:'var(--muted)', margin:'-12px 0 28px'}}>
              {hpTx('La demande est enregistrée dans WordPress. La synchronisation atelier sera reprise manuellement si nécessaire.', 'The request is saved in WordPress. Workshop synchronization can be resumed manually if needed.')}
            </p>
          )}
           <a href={hpPath('home')} className="btn ghost">{hpTx("Retour à l'accueil", 'Back to home')}</a>
        </div>
      </section>
    );
  }

  const canProceed = () => {
    if (current.id === 'marque' && selectedMateriels.length > 1) {
      return selectedMateriels.every(m => (data.marques_modeles?.[m] || '').trim().length > 2);
    }
    if (current.type === 'text' || current.type === 'textarea') return (data[current.id] || '').length > 2;
    if (current.type === 'contact') {
      return !!(data.contact?.name && isValidEmail(data.contact?.email || '') && data.contact_consent === true);
    }
    if (current.multi) {
      const selected = Array.isArray(data[current.id]) && data[current.id].length > 0;
      if (current.id === 'materiel' && hasOtherMateriel) {
        return selected && (data.materiel_autre || '').trim().length > 2;
      }
      return selected;
    }
    return !!data[current.id];
  };

  const toggleMulti = (val) => {
    const cur = Array.isArray(data[current.id]) ? data[current.id] : [];
    setField(current.id, cur.includes(val) ? cur.filter(v => v !== val) : [...cur, val]);
  };

  const setMaterielModel = (materiel, value) => {
    setField('marques_modeles', {
      ...(data.marques_modeles || {}),
      [materiel]: value,
    });
  };

  const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(value).trim());

  async function submitQuoteRequest() {
    if (!canProceed() || isSubmitting) return;

    const api = window.HOSTOPHOTO_QUOTE_API || {};
    if (!api.endpoint) {
      setSubmitError("Le formulaire n'est pas encore configuré côté WordPress.");
      return;
    }

    setIsSubmitting(true);
    setSubmitError('');

    try {
      const response = await fetch(api.endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(api.nonce ? { 'X-WP-Nonce': api.nonce } : {}),
        },
        body: JSON.stringify(data),
      });

      const payload = await response.json().catch(() => ({}));
      if (!response.ok || !payload.ok) {
        throw new Error(payload.message || payload?.data?.message || "Impossible d'envoyer la demande.");
      }

      if (typeof window.hostophotoTrackEvent === 'function') {
        window.hostophotoTrackEvent('generate_lead', {
          lead_source: 'repair_quote',
          form_name: 'repair_quote_request',
          language: hpLang(),
          equipment_count: selectedMateriels.length,
        });
      }

      setSubmitResult(payload);
      setSubmitted(true);
    } catch (error) {
      setSubmitError(error.message || "Impossible d'envoyer la demande.");
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <>
      {/* HERO ÉDITORIAL */}
      <section style={{padding:'80px 0 60px', borderBottom:'1px solid var(--hair)'}}>
        <div className="container">
          <div className="kicker" style={{marginBottom:24}}>{hpTx('DEMANDE DE PRISE EN CHARGE · GRATUIT · RÉPONSE SOUS 48H', 'INTAKE REQUEST · FREE · REPLY WITHIN 48H')}</div>
          <h1 style={{fontSize:'clamp(3rem, 6.5vw, 5.5rem)', lineHeight:0.98, maxWidth:1000, marginBottom:32}}>
            {hpLang() === 'en' ? <>Tell me about your <em style={{fontStyle:'italic', color:'var(--accent)'}}>equipment</em>.</> : <>Parlons de votre <em style={{fontStyle:'italic', color:'var(--accent)'}}>matériel</em>.</>}
          </h1>
          <p className="lede" style={{maxWidth:720}}>
            {hpTx("Vous décrivez votre matériel, je vous confirme d'abord si je peux le prendre en charge, puis vous l'envoyez à l'atelier. Le devis chiffré arrive après réception et diagnostic, selon la file d'attente du moment.", 'Describe the equipment first. I confirm whether I can take it in, then you send it to the workshop. The priced quote comes later, after reception and diagnosis, depending on the current queue.')}
          </p>
        </div>
      </section>

      {/* TIMELINE DU PROCESS */}
      <ProcessTimeline />

      {/* ACCÈS COMPTE CLIENT */}
      <ClientAccessStrip />

      {/* FORMULAIRE */}
      <section style={{padding:'40px 0 100px', borderTop:'1px solid var(--hair)'}}>
        <div className="container" style={{marginBottom:48}}>
          <div className="kicker" style={{marginBottom:16}}>{hpTx('ÉTAPE 01 · LE FORMULAIRE', 'STEP 01 · THE FORM')}</div>
          <h2 style={{fontSize:'clamp(2rem, 4vw, 3rem)', maxWidth:760, fontWeight:500}}>
            {hpTx('Démarrons par votre demande.', 'Let’s start with your request.')}
          </h2>
        </div>
      </section>

      <section style={{paddingBottom:100, marginTop:-60}}>
        <div className="container" style={{maxWidth:820}}>
          <div className="quote-form-card" style={{
            background:'var(--paper-2)', borderRadius:8, border:'1px solid var(--hair)',
          }}>
            {/* progress */}
            <div style={{display:'flex', gap:4, marginBottom:32}}>
              {quoteSteps.map((s, i) => (
                <div key={s.id} style={{
                  flex:1, height:3,
                  background: i <= step ? 'var(--accent)' : 'var(--hair)',
                  transition:'background .3s',
                }}/>
              ))}
            </div>

            <div style={{display:'flex', justifyContent:'space-between', marginBottom:28, fontFamily:'var(--font-mono)', fontSize:11, letterSpacing:'0.14em', textTransform:'uppercase', color:'var(--muted)'}}>
              <span>{hpTx('Étape', 'Step')} {step+1} / {quoteSteps.length}</span>
              <span>{current.title}</span>
            </div>

            <h2 style={{fontSize:'2rem', marginBottom: current.hint ? 8 : 32, fontWeight:500}}>{current.question}</h2>
            {current.hint && (
              <div style={{fontFamily:'var(--font-mono)', fontSize:11, letterSpacing:'0.14em', textTransform:'uppercase', color:'var(--muted)', marginBottom:24}}>
                {current.hint}
              </div>
            )}

            {current.options && (
              <div style={{display:'grid', gap:10, marginBottom: hasOtherMateriel && current.id === 'materiel' ? 8 : 40}}>
                {current.options.map(o => {
                  const active = current.multi
                    ? Array.isArray(data[current.id]) && data[current.id].includes(o)
                    : data[current.id] === o;
                  const handle = () => current.multi ? toggleMulti(o) : setField(current.id, o);
                  return (
                    <button key={o} onClick={handle}
                      className={`quote-option ${active ? 'is-active' : ''}`}
                      style={{
                        padding:'16px 20px', textAlign:'left', fontFamily:'inherit', fontSize:15,
                        border: active ? '1.5px solid var(--accent)' : '1px solid rgba(244,239,230,0.24)',
                        background: active ? 'var(--paper)' : 'rgba(244,239,230,0.04)',
                        color: 'var(--ink)',
                        borderRadius:4, cursor:'pointer',
                        display:'flex', justifyContent:'space-between', alignItems:'center', gap:12,
                      }}>
                      <span style={{display:'flex', alignItems:'center', gap:14}}>
                        {current.multi && (
                          <span style={{
                            width:18, height:18, borderRadius:3, flexShrink:0,
                            border: active ? '1.5px solid var(--accent)' : '1.5px solid rgba(244,239,230,0.52)',
                            background: active ? 'var(--accent)' : 'transparent',
                            display:'grid', placeItems:'center',
                          }}>
                            {active && (
                              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="var(--accent-ink)" strokeWidth="3.5">
                                <path d="M5 12l5 5 10-12"/>
                              </svg>
                            )}
                          </span>
                        )}
                        <span className="quote-option-label">{o}</span>
                      </span>
                      {!current.multi && active && <span style={{color:'var(--accent)'}}>✓</span>}
                    </button>
                  );
                })}
              </div>
            )}

            {current.id === 'materiel' && hasOtherMateriel && (
              <div style={{paddingLeft:32, marginBottom:40}}>
                <textarea value={data.materiel_autre || ''} onChange={e=>setField('materiel_autre', e.target.value)}
                  placeholder={hpTx('Précisez le type de matériel', 'Specify the type of equipment')}
                  rows={2}
                  style={{
                    width:'calc(100% - 32px)', maxWidth:560,
                    padding:'13px 16px', fontFamily:'inherit', fontSize:15,
                    border:'1px solid var(--hair)', borderRadius:4, background:'var(--paper)',
                    color:'var(--ink)', caretColor:'var(--accent)', resize:'vertical', lineHeight:1.4,
                  }}/>
              </div>
            )}

            {current.id === 'marque' && selectedMateriels.length > 1 && (
              <div style={{display:'grid', gap:14, marginBottom:40}}>
                {selectedMateriels.map(materiel => (
                  <label key={materiel} style={{display:'grid', gap:7}}>
                    <span style={{
                      fontFamily:'var(--font-mono)', fontSize:11, letterSpacing:'0.12em',
                      textTransform:'uppercase', color:'var(--ink)',
                    }}>
                      {materiel}
                    </span>
                    <input value={data.marques_modeles?.[materiel] || ''} onChange={e=>setMaterielModel(materiel, e.target.value)}
                      placeholder={hpTx('Marque et modèle', 'Brand and model')}
                      style={{
                        width:'100%', padding:'14px 18px', fontFamily:'inherit', fontSize:15,
                        border:'1px solid var(--hair)', borderRadius:4, background:'var(--paper)',
                        color:'var(--ink)', caretColor:'var(--accent)',
                      }}/>
                  </label>
                ))}
              </div>
            )}

            {current.type === 'text' && !(current.id === 'marque' && selectedMateriels.length > 1) && (
              <input value={data[current.id] || ''} onChange={e=>setField(current.id, e.target.value)}
                placeholder={current.placeholder}
                style={{
                  width:'100%', padding:'16px 20px', fontFamily:'inherit', fontSize:16,
                  border:'1px solid var(--hair)', borderRadius:4, background:'var(--paper)',
                  color:'var(--ink)', caretColor:'var(--accent)', marginBottom:40,
                }}/>
            )}

            {current.type === 'textarea' && (
              <textarea value={data[current.id] || ''} onChange={e=>setField(current.id, e.target.value)}
                placeholder={current.placeholder} rows={6}
                style={{
                  width:'100%', padding:'16px 20px', fontFamily:'inherit', fontSize:16,
                  border:'1px solid var(--hair)', borderRadius:4, background:'var(--paper)',
                  color:'var(--ink)', caretColor:'var(--accent)', marginBottom:40,
                  resize:'vertical',
                }}/>
            )}

            {current.type === 'contact' && (
              <div className="hp-form-grid" style={{gap:12, marginBottom:40}}>
                <label style={fieldLabel()}>
                  <span>{hpTx('Nom complet', 'Full name')}</span>
                  <input placeholder={hpTx('ex. Élise Marchand', 'e.g. Elise Marchand')}
                    value={data.contact?.name || ''}
                    onChange={e=>setField('contact', {...(data.contact||{}), name:e.target.value})}
                    style={inp()}/>
                </label>
                <label style={fieldLabel()}>
                  <span>{hpTx('Adresse email', 'Email address')}</span>
                  <input type="email" placeholder={hpTx('ex. vous@email.fr', 'e.g. you@email.com')}
                    value={data.contact?.email || ''}
                    onChange={e=>setField('contact', {...(data.contact||{}), email:e.target.value})}
                    style={inp()}/>
                  {data.contact?.email && !isValidEmail(data.contact.email) && (
                    <span style={{
                      fontFamily:'var(--font-body)', fontSize:13, letterSpacing:0,
                      textTransform:'none', color:'var(--accent)', marginTop:-2,
                    }}>
                      {hpTx('Adresse email invalide.', 'Invalid email address.')}
                    </span>
                  )}
                </label>
                <label style={fieldLabel()}>
                  <span>{hpTx('Téléphone', 'Phone')} <em style={{fontStyle:'normal', color:'var(--muted)'}}>{hpTx('(facultatif)', '(optional)')}</em></span>
                  <input type="tel" placeholder={hpTx('ex. 06 12 34 56 78', 'e.g. +33 6 12 34 56 78')}
                    value={data.contact?.phone || ''}
                    onChange={e=>setField('contact', {...(data.contact||{}), phone:e.target.value})}
                    style={inp()}/>
                </label>
                <label style={{display:'flex', gap:10, alignItems:'start', fontSize:14, color:'var(--ink)', marginTop:8, lineHeight:1.45}}>
                  <input
                    type="checkbox"
                    checked={data.contact_consent === true}
                    onChange={e=>setField('contact_consent', e.target.checked)}
                    style={{marginTop:4}}
                  />
                  <span>{hpTx("J'accepte d'être recontacté au sujet de ma demande. Aucune donnée n'est transmise à des tiers.", 'I agree to be contacted about my request. No data is shared with third parties.')}</span>
                </label>
              </div>
            )}

            <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
              <button onClick={prev} disabled={step === 0}
                style={{
                  background:'transparent', border:'none', cursor: step === 0 ? 'default' : 'pointer',
                  fontFamily:'var(--font-mono)', fontSize:11, letterSpacing:'0.14em', textTransform:'uppercase',
                  color: step === 0 ? 'var(--hair)' : 'var(--muted)', padding:'10px 0',
                }}>
                ← {hpTx('Précédent', 'Previous')}
              </button>
              <button onClick={next} disabled={!canProceed()} className="btn"
                style={{opacity: canProceed() && !isSubmitting ? 1 : 0.4, pointerEvents: canProceed() && !isSubmitting ? 'auto' : 'none'}}>
                {step === quoteSteps.length - 1 ? (isSubmitting ? hpTx('Envoi en cours...', 'Sending...') : hpTx('Envoyer la demande', 'Send request')) : hpTx('Continuer', 'Continue')} <span className="arrow"/>
              </button>
            </div>
            {submitError && (
              <div style={{
                marginTop:18, padding:'12px 14px', border:'1px solid var(--accent)',
                borderRadius:4, color:'var(--accent)', fontSize:14, lineHeight:1.45,
              }}>
                {submitError}
              </div>
            )}
          </div>

          <div className="hp-grid-3 hp-benefit-grid" style={{marginTop:48, padding:'32px', border:'1px solid var(--hair)', borderRadius:4, gap:24}}>
            {[
              [hpTx('Gratuit', 'Free'), hpTx('Le devis ne vous engage à rien.', 'The quote does not commit you to anything.')],
              [hpTx('Sous 48h', 'Within 48h'), hpTx("Réponse sur l'acceptation ou le refus de prise en charge.", 'Reply on whether the intake is accepted or refused.')],
              [hpTx('Honnête', 'Honest'), hpTx("Si c'est irréparable, vous le saurez.", 'If it cannot be repaired, I will tell you.')],
            ].map(([t,d]) => (
              <div key={t}>
                <div style={{fontFamily:'var(--font-display)', fontSize:24, marginBottom:6}}>{t}</div>
                <div style={{fontSize:13, color:'var(--muted)'}}>{d}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );

  function inp() {
    return {
      width:'100%', padding:'14px 18px', fontFamily:'inherit', fontSize:15,
      border:'1px solid var(--hair)', borderRadius:4, background:'var(--paper)',
      color:'var(--ink)', caretColor:'var(--accent)',
    };
  }

  function fieldLabel() {
    return {
      display:'grid', gap:7,
      fontFamily:'var(--font-mono)', fontSize:11, letterSpacing:'0.12em',
      textTransform:'uppercase', color:'var(--ink)',
    };
  }
}

function ContactPage() {
  return (
    <>
      <section style={{padding:'60px 0 40px', borderBottom:'1px solid var(--hair)'}}>
        <div className="container">
          <div className="kicker" style={{marginBottom:16}}>CONTACT</div>
          <h1 style={{fontSize:'clamp(3rem, 6vw, 5rem)', maxWidth:900}}>
            Contact
          </h1>
        </div>
      </section>

      <section className="section">
        <div className="container hp-split hp-contact-grid">
          <div>
            <h2 style={{fontSize:'2rem', marginBottom:32}}>{hpTx("L'atelier", 'The workshop')}</h2>
            <div style={{display:'grid', gap:28}}>
              <InfoRow label={hpTx('ZONE', 'AREA')} v={hpLang() === 'en' ? <>Workshop between Marseille<br/>and Aix-en-Provence<br/>Address by appointment</> : <>Atelier entre Marseille<br/>et Aix-en-Provence<br/>Adresse sur rendez-vous</>}/>
              <InfoRow label="EMAIL" v={<a href="mailto:atelier@hostophoto.fr" style={{textDecoration:'underline'}}>atelier@hostophoto.fr</a>}/>
              <InfoRow label={hpTx('TÉLÉPHONE', 'PHONE')} v="+33 (0)6 37 99 21 86"/>
            </div>

            <div style={{marginTop:48, padding:'24px', background:'var(--paper-2)', borderRadius:4}}>
              <div className="kicker" style={{marginBottom:10}}>{hpTx('ENVOI PAR COLIS', 'SHIPPING BY PARCEL')}</div>
              <p style={{fontSize:14, color:'var(--ink-soft)', margin:0, lineHeight:1.55}}>
                {hpTx("Vous n'êtes pas dans la région ? Passez d'abord par la demande de devis. Après validation de votre demande de prise en charge, vous recevez les instructions nécessaires pour m'envoyer votre matériel.", 'Not local? Start with the quote request. Once your intake request is accepted, you receive the instructions needed to ship your equipment.')}
              </p>
              <a href={hpPath('devis')} className="linky" style={{display:'inline-block', marginTop:12}}>{hpTx('faire une demande de devis →', 'start a quote request →')}</a>
            </div>
          </div>

          <div>
            <h2 style={{fontSize:'2rem', marginBottom:24}}>{hpTx("Écrire à l'atelier", 'Write to the workshop')}</h2>
            <div style={{
              padding:'28px',
              background:'var(--paper-2)',
              border:'1px solid var(--hair)',
              borderRadius:6,
              display:'grid',
              gap:18,
            }}>
              <p style={{fontSize:16, color:'var(--ink-soft)', margin:0, lineHeight:1.65}}>
                {hpTx("Pour une réparation ou une prise en charge, passez par le formulaire de devis. Pour un échange déjà en cours, écrivez directement à l'adresse atelier.", 'For a repair or intake request, use the quote form. For an ongoing conversation, write directly to the workshop email address.')}
              </p>
              <div style={{display:'flex', gap:12, flexWrap:'wrap'}}>
                <a className="btn" href="mailto:atelier@hostophoto.fr">atelier@hostophoto.fr <span className="arrow"/></a>
                <a className="btn ghost" href={hpPath('devis')}>{hpTx('Demande de devis', 'Quote request')}</a>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  );

  function inp() {
    return {
      width:'100%', padding:'14px 18px', fontFamily:'inherit', fontSize:15,
      border:'1px solid var(--hair)', borderRadius:4, background:'var(--paper)',
      color:'var(--ink)', caretColor:'var(--accent)',
    };
  }
}

function InfoRow({ label, v }) {
  return (
    <div>
      <div style={{fontFamily:'var(--font-mono)', fontSize:11, letterSpacing:'0.16em', color:'var(--muted)', marginBottom:8}}>{label}</div>
      <div style={{fontSize:17, lineHeight:1.5}}>{v}</div>
    </div>
  );
}

Object.assign(window, { DevisPage, ContactPage, ProcessTimeline, ClientAccessStrip });



/* src/account.jsx */
/* Mon Compte - espace utilisateur HostoPhoto
   Dashboard atelier : fiches de rÃ©paration, commandes, devis, collection. */

const ACCOUNT_USER = window.HOSTOPHOTO_ACCOUNT_USER || {
  isLoggedIn: false,
  firstName: '',
  lastName: '',
  displayName: '',
  email: '',
  phone: '',
  address: '',
  member_since: '',
  client_n: '',
  loginUrl: '/wp-login.php?redirect_to=/compte/',
  loginPostUrl: '/wp-login.php',
  logoutUrl: '/',
  lostPasswordUrl: '/wp-login.php?action=lostpassword',
  registerUrl: '/wp-login.php?action=register',
  redirectTo: '/compte/',
};

function accountTx(fr, en) {
  return typeof hpTx === 'function' ? hpTx(fr, en) : fr;
}

function accountDate(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString(hpLang() === 'en' ? 'en-US' : 'fr-FR');
}

/* ---- Sub-components ---- */

function StatusPill({ status, children }) {
  const map = {
    atelier: { bg: 'var(--accent)', fg: 'var(--accent-ink)' },
    devis: { bg: '#e8c77a', fg: '#1a1612' },
    rendu: { bg: '#1a1612', fg: '#f4efe6' },
    expédiée: { bg: '#e8c77a', fg: '#1a1612' },
    livrée: { bg: '#1a1612', fg: '#f4efe6' },
    accepté: { bg: '#1a1612', fg: '#f4efe6' },
    refusé: { bg: 'transparent', fg: 'var(--muted)', border: '1px solid var(--hair)' },
    attente: { bg: '#e8c77a', fg: '#1a1612' },
    ok: { bg: 'transparent', fg: 'var(--ink)', border: '1px solid var(--hair)' },
  };
  const s = map[status] || map.ok;
  return (
    <span className="status-pill" style={{
      background: s.bg, color: s.fg, border: s.border || 'none',
    }}>{children}</span>
  );
}

const QUOTE_PUBLIC_STATUS = {
  received: {
    label: accountTx('Demande reÃ§ue', 'Request received'),
    detail: accountTx("Votre demande a bien Ã©tÃ© transmise Ã  l'atelier.", 'Your request has been sent to the workshop.'),
    tone: 'attente',
  },
  accepted_waiting_reception: {
    label: accountTx('AcceptÃ©e - en attente de rÃ©ception', 'Accepted - waiting for reception'),
    detail: accountTx('Vous pouvez envoyer votre matÃ©riel. Le devis chiffrÃ© sera prÃ©parÃ© aprÃ¨s rÃ©ception et diagnostic.', 'You can ship your equipment. The priced quote will be prepared after reception and diagnosis.'),
    tone: 'acceptÃ©',
  },
  rejected: {
    label: accountTx('Demande refusÃ©e', 'Request declined'),
    detail: accountTx("La demande ne peut pas Ãªtre prise en charge par l'atelier.", 'This request cannot be handled by the workshop.'),
    tone: 'refusÃ©',
  },
  converted: {
    label: accountTx('Convertie en dossier atelier', 'Converted into workshop file'),
    detail: accountTx('La demande est rattachÃ©e Ã  un dossier atelier.', 'The request is linked to a workshop file.'),
    tone: 'acceptÃ©',
  },
  quote_accepted: {
    label: accountTx('Devis acceptÃ©', 'Quote accepted'),
    detail: accountTx("Le devis a Ã©tÃ© validÃ© et le dossier continue Ã  l'atelier.", 'The quote has been approved and the workshop file continues.'),
    tone: 'acceptÃ©',
  },
  quote_rejected: {
    label: accountTx('Devis refusÃ©', 'Quote declined'),
    detail: accountTx('Le devis a Ã©tÃ© refusÃ©.', 'The quote has been declined.'),
    tone: 'refusÃ©',
  },
};

function getQuotePublicStatus(request) {
  const status = request.public_status === 'received' && request.app_carton_reference
    ? 'accepted_waiting_reception'
    : request.public_status || (request.app_carton_reference ? 'accepted_waiting_reception' : 'received');
  return QUOTE_PUBLIC_STATUS[status] || {
    label: status.replaceAll('_', ' '),
    detail: request.public_status_message || '',
    tone: 'attente',
  };
}

function isAcceptedQuoteRequest(request) {
  return (request.public_status === 'accepted_waiting_reception' || request.app_carton_reference) && request.public_status !== 'rejected';
}

const CARTON_PUBLIC_STATUS = {
  attente_reception: { label: accountTx('En attente de rÃ©ception', 'Waiting for reception'), tone: 'attente' },
  recu: { label: accountTx("ReÃ§u Ã  l'atelier", 'Received at the workshop'), tone: 'atelier' },
  en_diagnostic: { label: accountTx('Diagnostic en cours', 'Diagnosis in progress'), tone: 'atelier' },
  devis_envoye: { label: accountTx('Devis envoyÃ©', 'Quote sent'), tone: 'devis' },
  en_cours: { label: accountTx('RÃ©paration en cours', 'Repair in progress'), tone: 'atelier' },
  termine: { label: accountTx('TerminÃ©', 'Completed'), tone: 'rendu' },
  facture: { label: accountTx('Facture envoyÃ©e', 'Invoice sent'), tone: 'devis' },
  paye: { label: accountTx('RÃ©glÃ©', 'Paid'), tone: 'ok' },
  renvoye: { label: accountTx('Retour expÃ©diÃ©', 'Return shipped'), tone: 'rendu' },
};

const TRAVAIL_PUBLIC_STATUS = {
  attente_devis: accountTx('En attente de devis', 'Waiting for quote'),
  devis_pret: accountTx('Devis prÃªt', 'Quote ready'),
  devis_envoye: accountTx('Devis envoyÃ©', 'Quote sent'),
  accepte: accountTx('AcceptÃ©', 'Accepted'),
  refuse: accountTx('RefusÃ©', 'Declined'),
  en_cours: accountTx('En cours', 'In progress'),
  termine: accountTx('TerminÃ©', 'Completed'),
};

const CARTON_QUOTE_DECISION = {
  pending: {
    label: accountTx('En attente de décision', 'Waiting for your decision'),
    detail: accountTx('Le devis est disponible et attend votre retour.', 'The quote is available and waiting for your answer.'),
    tone: 'devis',
  },
  accepted: {
    label: accountTx('Devis accepté', 'Quote accepted'),
    detail: accountTx('Le devis a été validé.', 'The quote has been approved.'),
    tone: 'accepté',
  },
  rejected: {
    label: accountTx('Devis refusé', 'Quote declined'),
    detail: accountTx('Le devis a été refusé.', 'The quote has been declined.'),
    tone: 'refusé',
  },
  partial: {
    label: accountTx('Decision partielle', 'Partial decision'),
    detail: accountTx('Certains travaux sont acceptes et d autres refuses.', 'Some jobs have been accepted and others declined.'),
    tone: 'devis',
  },
};

const CARTON_PAYMENT_STATUS = {
  none: {
    label: accountTx('Aucune facture', 'No invoice'),
    detail: '',
    tone: 'ok',
  },
  pending: {
    label: accountTx('Paiement en attente', 'Payment pending'),
    detail: accountTx('La facture est disponible. Vous pouvez rÃ©gler en ligne.', 'The invoice is available. You can pay online.'),
    tone: 'devis',
  },
  paid: {
    label: accountTx('RÃ©glÃ©', 'Paid'),
    detail: accountTx('Paiement confirmÃ©.', 'Payment confirmed.'),
    tone: 'ok',
  },
};

function getCartonPublicStatus(carton) {
  const status = carton?.statut || 'recu';
  return CARTON_PUBLIC_STATUS[status] || {
    label: status.replaceAll('_', ' '),
    tone: 'atelier',
  };
}

function formatPortalDate(value) {
  return accountDate(value);
}

function getWorkshopCartons(portal) {
  return Array.isArray(portal?.cartons) ? portal.cartons : [];
}

function getAccountName() {
  return ACCOUNT_USER.displayName || [ACCOUNT_USER.firstName, ACCOUNT_USER.lastName].filter(Boolean).join(' ') || accountTx('Votre compte', 'Your account');
}

function getAccountFirstName() {
  return ACCOUNT_USER.firstName || getAccountName();
}

function getAccountInitials() {
  const base = [ACCOUNT_USER.firstName, ACCOUNT_USER.lastName].filter(Boolean);
  if (base.length === 0) return 'HP';
  return base.map(part => part.trim()[0]).join('').slice(0, 2).toUpperCase();
}

function getClientReference(portal) {
  return portal?.client?.reference || ACCOUNT_USER.client_n || accountTx('Non rattachÃ©', 'Not linked');
}

function isOpenCarton(carton) {
  return !['termine', 'facture', 'paye', 'renvoye'].includes(carton.statut);
}

function getQuoteDecisionInfo(carton) {
  const status = carton?.quote_decision_status || 'pending';
  return CARTON_QUOTE_DECISION[status] || CARTON_QUOTE_DECISION.pending;
}

function getCartonPaymentInfo(carton) {
  const payment = carton?.facture || {};
  const status = payment.payment_status || 'none';
  return {
    ...payment,
    ui: CARTON_PAYMENT_STATUS[status] || CARTON_PAYMENT_STATUS.none,
  };
}

function getPortalApiEndpoint(path) {
  const api = window.HOSTOPHOTO_QUOTE_API || {};
  return api.endpoint ? api.endpoint.replace('/quote-requests', path) : '';
}

async function fetchPortalJson(path, options = {}) {
  const api = window.HOSTOPHOTO_QUOTE_API || {};
  const endpoint = getPortalApiEndpoint(path);
  if (!endpoint) throw new Error('API portail indisponible.');

  const headers = { ...(options.headers || {}) };
  if (api.nonce) headers['X-WP-Nonce'] = api.nonce;

  const response = await fetch(endpoint, { ...options, headers });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.message || payload?.data?.message || 'Erreur portail.');
  }
  return payload;
}

function sanitizeQuoteDetailHtml(value) {
  if (!value) return '';
  if (typeof window === 'undefined' || typeof window.DOMParser === 'undefined') return String(value);

  const allowedTags = new Set(['A', 'B', 'BR', 'EM', 'I', 'LI', 'OL', 'P', 'STRONG', 'UL']);
  const allowedAttrs = { A: new Set(['href', 'target', 'rel']) };
  const doc = new window.DOMParser().parseFromString(`<div>${String(value)}</div>`, 'text/html');
  const root = doc.body.firstElementChild;
  if (!root) return '';

  root.querySelectorAll('*').forEach(node => {
    if (!allowedTags.has(node.tagName)) {
      node.replaceWith(...Array.from(node.childNodes));
      return;
    }

    Array.from(node.attributes).forEach(attr => {
      const allowed = allowedAttrs[node.tagName]?.has(attr.name);
      if (!allowed || attr.name.startsWith('on')) node.removeAttribute(attr.name);
    });

    if (node.tagName === 'A') {
      const href = node.getAttribute('href') || '';
      if (!/^https?:\/\//i.test(href) && !/^mailto:/i.test(href)) {
        node.removeAttribute('href');
      }
      node.setAttribute('rel', 'noopener noreferrer');
      if (!node.getAttribute('target')) node.setAttribute('target', '_blank');
    }
  });

  return root.innerHTML;
}

function DashboardOverview({ onNav, portal, portalLoading, portalError }) {
  const cartons = getWorkshopCartons(portal);
  const hasPortal = Boolean(portal);
  const open = hasPortal ? cartons.filter(isOpenCarton) : [];
  const pendingQuotes = hasPortal
    ? cartons.filter(carton => carton.quote_can_decide && (carton.quote_decision_status || 'pending') === 'pending').length
    : 0;
  const clientReference = getClientReference(portal);
  return (
    <div className="acct-section">
      <div className="acct-greet">
        <p className="eyebrow">{accountTx('Bonjour', 'Hello')}</p>
        <h1>{accountTx(`${getAccountFirstName()}, vos boitiers vont bien.`, `${getAccountFirstName()}, your cameras are in good hands.`)}</h1>
        <p className="lede">
          {portalLoading
            ? accountTx("Synchronisation avec l'atelier en cours.", 'Synchronizing with the workshop.')
            : accountTx(`${open.length} intervention${open.length > 1 ? 's' : ''} en cours dans l'atelier.`, `${open.length} active workshop job${open.length > 1 ? 's' : ''}.`)}
          {portalError ? accountTx(' Le statut atelier est temporairement indisponible.', ' Workshop status is temporarily unavailable.') : ''}
        </p>
      </div>

      <div className="kpi-grid">
        <button className="kpi" onClick={() => onNav('reparations')}>
          <span className="kpi-n">{open.length}</span>
          <span className="kpi-l">{accountTx('RÃ©parations en cours', 'Repairs in progress')}</span>
          <span className="kpi-arrow"/>
        </button>
        <button className="kpi" onClick={() => onNav('reparations')}>
          <span className="kpi-n">{pendingQuotes}</span>
          <span className="kpi-l">{accountTx('Devis en attente', 'Pending quotes')}</span>
          <span className="kpi-arrow"/>
        </button>
        <button className="kpi" onClick={() => onNav('commandes')}>
          <span className="kpi-n">0</span>
          <span className="kpi-l">{accountTx('Commandes (12 mois)', 'Orders (12 months)')}</span>
          <span className="kpi-arrow"/>
        </button>
        <div className="kpi" style={{cursor:'default'}}>
          <span className="kpi-n">{clientReference}</span>
          <span className="kpi-l">{ACCOUNT_USER.member_since ? accountTx(`Compte client depuis ${ACCOUNT_USER.member_since}`, `Customer account since ${ACCOUNT_USER.member_since}`) : accountTx('Compte client', 'Customer account')}</span>
        </div>
      </div>

      {/* RÃ©paration focus */}
      <div className="block-head">
        <h2>{accountTx("En cours dans l'atelier", 'Currently at the workshop')}</h2>
        <a className="linky" onClick={() => onNav('reparations')} style={{cursor:'pointer'}}>{accountTx('Toutes les fiches ->', 'All files ->')}</a>
      </div>

      <div className="repair-stack">
        {open.slice(0, 3).map(carton => <WorkshopCartonCard key={carton.id} carton={carton}/>)}
        {!portalLoading && open.length === 0 && (
          <p className="muted">{accountTx('Aucune rÃ©paration en cours pour ce compte.', 'No repair in progress for this account.')}</p>
        )}
      </div>

      <div className="block-head" style={{marginTop:64}}>
        <h2>{accountTx('DerniÃ¨re commande', 'Latest order')}</h2>
        <a className="linky" onClick={() => onNav('commandes')} style={{cursor:'pointer'}}>{accountTx("Tout l'historique ->", 'Full history ->')}</a>
      </div>
      <p className="muted">{accountTx('Aucune commande rattachÃ©e Ã  ce compte pour le moment.', 'No order is linked to this account yet.')}</p>
    </div>
  );
}

function RepairCard({ repair }) {
  return (
    <article className="fiche">
      <header className="fiche-head">
        <div>
          <span className="fiche-n">{repair.id}</span>
          <h3>{repair.item}</h3>
          <p className="fiche-meta">
            <span>NÂ° sÃ©rie {repair.serial}</span>
            <span>Â·</span>
            <span>ReÃ§u le {repair.received}</span>
            <span>Â·</span>
            <span>{repair.estimated}</span>
          </p>
        </div>
        <StatusPill status={repair.status}>{repair.statusLabel}</StatusPill>
      </header>

      <div className="fiche-track">
        {repair.steps.map((s, i) => (
          <div key={i} className={`step ${s.done ? 'done' : ''} ${s.current ? 'current' : ''}`}>
            <div className="step-dot"/>
            <div className="step-label">{s.label}</div>
            <div className="step-date">{s.date}</div>
          </div>
        ))}
      </div>

      <div className="fiche-body">
        <div className="fiche-note">
          <p className="eyebrow" style={{marginBottom:8}}>Note de l'atelier</p>
          <p className="note-text">"{repair.tech_note}"</p>
          <p className="note-sig">- David, atelier HostoPhoto</p>
        </div>
        <div className="fiche-side">
          <div className="kv">
            <span>Devis</span>
            <span className="mono">{repair.quote}â‚¬</span>
          </div>
          <div className="kv">
            <span>RÃ¨glement</span>
            <span className="mono">{repair.paid ? 'RÃ©glÃ©' : "Ã€ l'enlÃ¨vement"}</span>
          </div>
          <div className="fiche-actions">
            {repair.status === 'devis' && (
              <>
                <button className="btn accent" style={{padding:'10px 16px', fontSize:13}}>Accepter le devis</button>
                <button className="btn ghost" style={{padding:'10px 16px', fontSize:13}}>Discuter</button>
              </>
            )}
            {repair.status === 'atelier' && (
              <>
                <button className="btn ghost" style={{padding:'10px 16px', fontSize:13}}>Ã‰crire Ã  David</button>
              </>
            )}
            {repair.status === 'rendu' && (
              <>
                <button className="btn ghost" style={{padding:'10px 16px', fontSize:13}}>TÃ©lÃ©charger la fiche PDF</button>
              </>
            )}
          </div>
        </div>
      </div>
    </article>
  );
}

function WorkshopCartonCard({ carton, onQuoteDecision, decisionLoadingId }) {
  const statusInfo = getCartonPublicStatus(carton);
  const quoteDecision = getQuoteDecisionInfo(carton);
  const paymentInfo = getCartonPaymentInfo(carton);
  const travaux = Array.isArray(carton.travaux) ? carton.travaux : [];
  const quotedTravaux = travaux.filter(travail => travail.prix_devis);
  const [draftDecisions, setDraftDecisions] = React.useState({});
  const createdAt = formatPortalDate(carton.created_at);
  const receivedAt = formatPortalDate(carton.date_reception);
  const sentAt = formatPortalDate(carton.date_envoi_client);
  const displayedDate = receivedAt || sentAt || createdAt;
  const isDecisionLoading = decisionLoadingId === carton.id;
  const canDecideQuote = Boolean(carton.quote_can_decide);
  const showInteractiveQuoteDecision = canDecideQuote && typeof onQuoteDecision === 'function';
  const canPayOnline = Boolean(paymentInfo.can_pay_online && paymentInfo.payment_url);
  const allQuoteChoicesReady = quotedTravaux.length > 0 && quotedTravaux.every(travail => {
    const decision = draftDecisions[travail.id];
    return decision === 'accept' || decision === 'reject';
  });

  React.useEffect(() => {
    const next = {};
    quotedTravaux.forEach(travail => {
      if (travail.statut === 'accepte') next[travail.id] = 'accept';
      if (travail.statut === 'refuse') next[travail.id] = 'reject';
    });
    setDraftDecisions(next);
  }, [carton.id, travaux.length]);

  return (
    <article className="fiche workshop-fiche">
      <header className="fiche-head">
        <div>
          <span className="fiche-n">{carton.reference}</span>
          <h3>{travaux.length > 0 ? `${travaux.length} intervention${travaux.length > 1 ? 's' : ''}` : 'Carton atelier'}</h3>
          <p className="fiche-meta">
            {displayedDate && <span>{receivedAt ? accountTx(`Reçu le ${displayedDate}`, `Received on ${displayedDate}`) : accountTx(`Créé le ${displayedDate}`, `Created on ${displayedDate}`)}</span>}
            {carton.transporteur_entrant && <span>{carton.transporteur_entrant}</span>}
            {carton.tracking_entrant && <span className="mono">{carton.tracking_entrant}</span>}
          </p>
        </div>
        <StatusPill status={statusInfo.tone}>{statusInfo.label}</StatusPill>
      </header>

      <div className="fiche-body">
        <div className="fiche-note">
          <p className="eyebrow" style={{marginBottom:8}}>{accountTx('Travaux rattachés', 'Linked jobs')}</p>
          {travaux.length === 0 && (
            <p className="note-text">{accountTx("Aucun travail n'a encore été créé dans ce carton.", 'No job has been created in this box yet.')}</p>
          )}
          {travaux.length > 0 && (
            <div className="workshop-work-list">
              {travaux.map(travail => {
                const title = [travail.equipement_marque, travail.equipement_modele].filter(Boolean).join(' ') || travail.reference;
                const workStatus = TRAVAIL_PUBLIC_STATUS[travail.statut] || travail.statut?.replaceAll('_', ' ');
                const quoteDetailHtml = sanitizeQuoteDetailHtml(travail.devis_detail || travail.diagnostic || '');
                return (
                  <div className="workshop-work-item" key={travail.id}>
                    <div>
                      <strong>{title}</strong>
                      {quoteDetailHtml && (
                        <div className="account-quote-work-detail" dangerouslySetInnerHTML={{ __html: quoteDetailHtml }} />
                      )}
                      {travail.numero_serie && <span className="muted small">{accountTx(`N° série ${travail.numero_serie}`, `Serial no. ${travail.numero_serie}`)}</span>}
                    </div>
                    <span className="mono small">{travail.prix_devis ? `${travail.prix_devis} euros` : workStatus}</span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div className="fiche-side">
          <div className="kv">
            <span>{accountTx('Carton', 'Box')}</span>
            <span className="mono">{carton.reference}</span>
          </div>
          <div className="kv">
            <span>Total</span>
            <span className="mono">{carton.total_ttc ? `${carton.total_ttc} euros` : accountTx('A definir', 'To be defined')}</span>
          </div>
          {canDecideQuote && (
            <div className="quote-decision-panel">
              <div className="quote-decision-head">
                <span>{accountTx('Décision devis', 'Quote decision')}</span>
                <StatusPill status={quoteDecision.tone}>{quoteDecision.label}</StatusPill>
              </div>
              <p className="muted small">{quoteDecision.detail}</p>
              {showInteractiveQuoteDecision && ['pending', 'partial'].includes(carton.quote_decision_status || 'pending') && quotedTravaux.length > 0 && (
                <div className="quote-work-decision-list">
                  {quotedTravaux.map(travail => {
                    const title = [travail.equipement_marque, travail.equipement_modele].filter(Boolean).join(' ') || travail.reference;
                    const quoteDetailHtml = sanitizeQuoteDetailHtml(travail.devis_detail || travail.diagnostic || '');
                    return (
                      <div className="quote-work-decision-row" key={travail.id}>
                        <div>
                          <strong>{title}</strong>
                          {quoteDetailHtml && (
                            <div className="account-quote-work-detail compact" dangerouslySetInnerHTML={{ __html: quoteDetailHtml }} />
                          )}
                          <span className="mono small">{travail.prix_devis} euros</span>
                        </div>
                        <div className="quote-work-choice">
                          <label>
                            <input
                              type="radio"
                              name={`quote-work-${travail.id}`}
                              checked={draftDecisions[travail.id] === 'accept'}
                              onChange={() => setDraftDecisions(prev => ({ ...prev, [travail.id]: 'accept' }))}
                            />
                            {accountTx('Accepter', 'Accept')}
                          </label>
                          <label>
                            <input
                              type="radio"
                              name={`quote-work-${travail.id}`}
                              checked={draftDecisions[travail.id] === 'reject'}
                              onChange={() => setDraftDecisions(prev => ({ ...prev, [travail.id]: 'reject' }))}
                            />
                            {accountTx('Refuser', 'Decline')}
                          </label>
                        </div>
                      </div>
                    );
                  })}
                  <div className="quote-decision-actions">
                    <button
                      className="btn accent"
                      style={{padding:'10px 14px', fontSize:12}}
                      onClick={() => onQuoteDecision(carton.id, '', quotedTravaux.map(travail => ({
                        travail_id: travail.id,
                        decision: draftDecisions[travail.id],
                      })))}
                      disabled={isDecisionLoading || !allQuoteChoicesReady}
                    >
                      {isDecisionLoading ? accountTx('Validation...', 'Saving...') : accountTx('Enregistrer mes choix', 'Save my choices')}
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
          {paymentInfo.has_invoice && (
            <div className="quote-decision-panel payment-panel">
              <div className="quote-decision-head">
                <span>{accountTx('Facture', 'Invoice')}</span>
                <StatusPill status={paymentInfo.ui.tone}>{paymentInfo.ui.label}</StatusPill>
              </div>
              {paymentInfo.invoice_number && (
                <div className="kv">
                  <span>{accountTx('Numéro', 'Number')}</span>
                  <span className="mono">{paymentInfo.invoice_number}</span>
                </div>
              )}
              {paymentInfo.invoice_paid_at && (
                <div className="kv">
                  <span>{accountTx('Réglée le', 'Paid on')}</span>
                  <span className="mono">{formatPortalDate(paymentInfo.invoice_paid_at)}</span>
                </div>
              )}
              {paymentInfo.ui.detail && <p className="muted small">{paymentInfo.ui.detail}</p>}
              {canPayOnline && (
                <a
                  className="btn accent"
                  style={{padding:'10px 14px', fontSize:12, justifyContent:'center'}}
                  href={paymentInfo.payment_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {accountTx('Payer en ligne', 'Pay online')}
                </a>
              )}
            </div>
          )}
          <div className="kv">
            <span>{accountTx('Dernière mise à jour', 'Last update')}</span>
            <span className="mono">{formatPortalDate(carton.updated_at) || createdAt || '-'}</span>
          </div>
          {carton.statut === 'attente_reception' && (
            <p className="muted small">{accountTx('Votre demande est acceptée. Le devis chiffré sera préparé après réception et diagnostic du matériel.', 'Your request has been accepted. The priced quote will be prepared after reception and diagnosis.')}</p>
          )}
        </div>
      </div>
    </article>
  );
}

function OrderRow({ order }) {
  return (
    <article className="order-row">
      <div className="order-col order-id">
        <span className="mono small">{order.id}</span>
        <span className="muted small">{order.date}</span>
      </div>
      <div className="order-col order-items">
        {order.items.map((it, i) => (
          <div key={i} className="order-item">
            <span className="thumb-mini"/>
            <span>{it.name}</span>
            <span className="muted">x{it.qty}</span>
          </div>
        ))}
      </div>
      <div className="order-col order-status">
        <StatusPill status={order.status}>{order.statusLabel}</StatusPill>
      </div>
      <div className="order-col order-total">
        <span className="mono">{order.total.toFixed(2)}â‚¬</span>
        <a className="linky" href="#">{'DÃ©tail ->'}</a>
      </div>
    </article>
  );
}

function QuoteRequestsPanel({ compact = false }) {
  const [quoteRequests, setQuoteRequests] = React.useState([]);
  const [quoteLoading, setQuoteLoading] = React.useState(false);
  const [quoteError, setQuoteError] = React.useState('');
  const [shippingRequestId, setShippingRequestId] = React.useState('');

  React.useEffect(() => {
    const api = window.HOSTOPHOTO_QUOTE_API || {};
    if (!api.isLoggedIn || !api.endpoint) return;

    const endpoint = api.endpoint.replace('/quote-requests', '/my-quote-requests');
    setQuoteLoading(true);
    fetch(endpoint, { headers: api.nonce ? { 'X-WP-Nonce': api.nonce } : {} })
      .then(response => response.json().then(payload => ({ response, payload })))
      .then(({ response, payload }) => {
        if (!response.ok || !payload.ok) {
          throw new Error(payload.message || 'Impossible de charger vos demandes.');
        }
        setQuoteRequests(Array.isArray(payload.items) ? payload.items : []);
      })
      .catch(error => setQuoteError(error.message || 'Impossible de charger vos demandes.'))
      .finally(() => setQuoteLoading(false));
  }, []);

  function markRequestShipped(request) {
    const api = window.HOSTOPHOTO_QUOTE_API || {};
    const postId = String(request.external_id || request.id || '').replace(/^wp-/i, '').replace(/^WP-/, '');
    if (!api.endpoint || !postId) return;

    const endpoint = api.endpoint.replace('/quote-requests', `/quote-requests/${postId}/mark-shipped`);
    setShippingRequestId(request.id);
    fetch(endpoint, {
      method: 'POST',
      headers: api.nonce ? { 'X-WP-Nonce': api.nonce } : {},
    })
      .then(response => response.json().then(payload => ({ response, payload })))
      .then(({ response, payload }) => {
        if (!response.ok || !payload.ok) {
          throw new Error(payload.message || accountTx('Impossible de marquer cette demande comme expÃ©diÃ©e.', 'Unable to mark this request as shipped.'));
        }
        setQuoteRequests(items => items.map(item => (
          item.id === request.id
            ? { ...item, client_shipping_status: payload.client_shipping_status, client_shipped_at: payload.client_shipped_at }
            : item
        )));
      })
      .catch(error => setQuoteError(error.message || accountTx('Impossible de marquer cette demande comme expÃ©diÃ©e.', 'Unable to mark this request as shipped.')))
      .finally(() => setShippingRequestId(''));
  }

  const isLoggedIn = Boolean(window.HOSTOPHOTO_QUOTE_API?.isLoggedIn);
  if (!isLoggedIn) return null;

  return (
    <div className="devis-list" style={{marginBottom: compact ? 34 : 28}}>
      <div className="block-head" style={{marginTop:0}}>
        <h2>{accountTx('Demandes de prise en charge', 'Repair intake requests')}</h2>
        <a href={hpPath('devis')} className="linky">{accountTx('Nouvelle demande ->', 'New request ->')}</a>
      </div>

      {quoteLoading && <p className="muted">{accountTx('Chargement des demandes...', 'Loading requests...')}</p>}
      {quoteError && <p style={{color:'var(--accent)'}}>{quoteError}</p>}
      {!quoteLoading && !quoteError && quoteRequests.length === 0 && (
        <p className="muted">{accountTx('Aucune demande en ligne rattachÃ©e Ã  ce compte pour le moment.', 'No online request is linked to this account yet.')}</p>
      )}

      {quoteRequests.map(request => {
        const payload = request.structured_payload || {};
        const statusInfo = getQuotePublicStatus(request);
        const accepted = isAcceptedQuoteRequest(request);
        const shipped = request.client_shipping_status === 'expedie';
        const shippingAddress = window.HOSTOPHOTO_QUOTE_API?.shippingAddress || accountTx("Adresse d'envoi Ã  complÃ©ter dans WordPress.", 'Shipping address to complete in WordPress.');
        const materiel = Array.isArray(payload.materiel) && payload.materiel.length
          ? payload.materiel.join(', ')
          : request.title;
        const createdAt = request.created_at ? new Date(request.created_at) : null;
        const date = createdAt && !Number.isNaN(createdAt.getTime())
          ? createdAt.toLocaleDateString(hpLang() === 'en' ? 'en-US' : 'fr-FR')
          : '';
        const priorityLabel = payload.traitement_privilegie ? accountTx('Traitement privilÃ©giÃ© demandÃ©', 'Priority handling requested') : accountTx('Traitement standard', 'Standard handling');

        return (
          <article key={request.id} className="devis-card quote-request-card">
            <header className="quote-request-head">
              <div className="quote-request-title">
                <span className="eyebrow">{accountTx('Demande de prise en charge', 'Repair intake request')}</span>
                <h4>{materiel}</h4>
              </div>
              <div className="quote-request-meta">
                <span className="mono small">{request.external_id || `WP-${request.id}`}</span>
                {date && <span className="muted small">{accountTx(`ReÃ§ue le ${date}`, `Received on ${date}`)}</span>}
              </div>
              <div className="quote-request-status">
                <StatusPill status={request.sync_status === 'failed' ? 'refusÃ©' : statusInfo.tone}>
                  {accepted && request.sync_status !== 'failed' && (
                    <span className="status-check-icon" aria-hidden="true">âœ“</span>
                  )}
                  {request.sync_status === 'failed' ? accountTx('Synchronisation en attente', 'Synchronization pending') : statusInfo.label}
                </StatusPill>
              </div>
            </header>

            <div className="quote-request-body">
              <div className="quote-request-summary">
                <div className="kv">
                  <span>{accountTx('Traitement', 'Handling')}</span>
                  <span className="mono">{priorityLabel}</span>
                </div>
                {request.app_carton_reference && (
                  <div className="kv">
                    <span>{accountTx('Dossier atelier', 'Workshop file')}</span>
                    <span className="mono">{request.app_carton_reference}</span>
                  </div>
                )}
                {statusInfo.detail && !accepted && request.sync_status !== 'failed' && (
                  <p className="muted small quote-status-detail">{statusInfo.detail}</p>
                )}
                {request.public_status_message && !accepted && request.sync_status !== 'failed' && (
                  <p className="muted small quote-status-detail">{request.public_status_message}</p>
                )}
                {request.sync_status === 'failed' && (
                  <p className="muted small quote-status-detail">{accountTx('Synchronisation atelier en attente.', 'Workshop synchronization pending.')}</p>
                )}
              </div>

              {accepted && (
                <div className="quote-accepted-box">
                  <p>{accountTx("Vous pouvez envoyer votre matÃ©riel Ã  l'adresse de l'atelier.", 'You can ship your equipment to the workshop address.')}</p>
                  <p className="mono small quote-shipping-address">{shippingAddress}</p>
                  <div className="quote-shipping-actions">
                    {shipped ? (
                      <StatusPill status="devis">{accountTx('ExpÃ©diÃ©', 'Shipped')}</StatusPill>
                    ) : (
                      <button
                        className="btn accent"
                        style={{padding:'9px 14px', fontSize:12}}
                        onClick={() => markRequestShipped(request)}
                        disabled={shippingRequestId === request.id}
                      >
                        {shippingRequestId === request.id ? accountTx('Enregistrementâ€¦', 'Saving...') : accountTx("C'est expÃ©diÃ©", 'It has shipped')}
                      </button>
                    )}
                  </div>
                </div>
              )}
            </div>
          </article>
        );
      })}
    </div>
  );
}

function RepairsSection({ portal, portalLoading, portalError }) {
  const [decisionError, setDecisionError] = React.useState('');
  const [decisionLoadingId, setDecisionLoadingId] = React.useState('');
  const [filter, setFilter] = React.useState('all');
  const cartons = getWorkshopCartons(portal);
  const hasPortal = Boolean(portal);
  const filteredCartons = cartons.filter(carton => {
    if (filter === 'all') return true;
    if (filter === 'atelier') return isOpenCarton(carton);
    if (filter === 'devis') return carton.quote_can_decide || carton.statut === 'devis_envoye';
    if (filter === 'rendu') return !isOpenCarton(carton);
    return true;
  });

  async function handleQuoteDecision(cartonId, decision, decisions = null) {
    setDecisionError('');
    setDecisionLoadingId(cartonId);
    try {
      const payload = { carton_id: cartonId };
      if (Array.isArray(decisions) && decisions.length > 0) {
        payload.decisions = decisions;
      } else {
        payload.decision = decision;
      }
      await fetchPortalJson('/quote-decision', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      window.dispatchEvent(new CustomEvent('hostophoto:portal-refresh'));
    } catch (error) {
      setDecisionError(error.message || accountTx("Impossible d'enregistrer votre dÃ©cision.", 'Unable to save your decision.'));
    } finally {
      setDecisionLoadingId('');
    }
  }

  return (
    <div className="acct-section">
      <div className="acct-greet">
        <p className="eyebrow">{accountTx('Mes demandes & rÃ©parations', 'My requests & repairs')}</p>
        <h1>{accountTx('Le suivi atelier.', 'Workshop tracking.')}</h1>
        <p className="lede">
          {accountTx("Retrouvez vos demandes en ligne, puis les cartons et travaux crÃ©Ã©s dans l'atelier.", 'Find your online requests, then the workshop boxes and jobs created for them.')}
          {portalError ? accountTx(' Le statut atelier est indisponible pour le moment.', ' Workshop status is unavailable for now.') : ''}
        </p>
      </div>

      <QuoteRequestsPanel compact/>
      {decisionError && <p style={{color:'var(--accent)'}}>{decisionError}</p>}

      <div className="block-head" style={{marginTop:18}}>
        <h2>{accountTx("Ã€ l'atelier", 'At the workshop')}</h2>
      </div>

      <div className="filter-bar">
        {[
          { id: 'all', label: accountTx('Toutes', 'All'), n: hasPortal ? cartons.length : 0 },
          { id: 'atelier', label: accountTx('En cours', 'In progress'), n: hasPortal ? cartons.filter(isOpenCarton).length : 0 },
          { id: 'devis', label: accountTx('Devis', 'Quotes'), n: hasPortal ? cartons.filter(r => r.quote_can_decide || r.statut === 'devis_envoye').length : 0 },
          { id: 'rendu', label: accountTx('Rendues', 'Returned'), n: hasPortal ? cartons.filter(r=>!isOpenCarton(r)).length : 0 },
        ].map(f => (
          <button key={f.id}
                  className={`filter-chip ${filter === f.id ? 'active' : ''}`}
                  onClick={() => setFilter(f.id)}>
            {f.label} <span className="mono small">{f.n}</span>
          </button>
        ))}
      </div>

      <div className="repair-stack">
        {portalLoading && <p className="muted">{accountTx('Chargement des statuts atelier...', 'Loading workshop statuses...')}</p>}
        {filteredCartons.map(carton => (
          <WorkshopCartonCard
            key={carton.id}
            carton={carton}
            onQuoteDecision={handleQuoteDecision}
            decisionLoadingId={decisionLoadingId}
          />
        ))}
        {!portalLoading && filteredCartons.length === 0 && (
          <p className="muted">{accountTx('Aucun carton dans cette catÃ©gorie.', 'No workshop box in this category.')}</p>
        )}
      </div>
    </div>
  );
}

function OrdersSection() {
  return (
    <div className="acct-section">
      <div className="acct-greet">
        <p className="eyebrow">{accountTx('Mes commandes', 'My orders')}</p>
        <h1>{accountTx('Boutique & tÃ©lÃ©chargements.', 'Shop & downloads.')}</h1>
        <p className="lede">{accountTx('Appareils, objectifs, accessoires, piÃ¨ces et documentation. Tout ce qui est passÃ© par la caisse.', 'Cameras, lenses, accessories, parts and documentation. Everything that went through checkout.')}</p>
      </div>
      <div className="orders-list">
        <div className="orders-head">
          <span>{accountTx('Commande', 'Order')}</span>
          <span>{accountTx('Articles', 'Items')}</span>
          <span>{accountTx('Ã‰tat', 'Status')}</span>
          <span style={{textAlign:'right'}}>Total</span>
        </div>
        <p className="muted" style={{padding:18}}>{accountTx('Aucune commande rattachÃ©e Ã  ce compte pour le moment.', 'No order is linked to this account yet.')}</p>
      </div>
    </div>
  );
}

function ProfileSection({ portal }) {
  const clientReference = getClientReference(portal);
  return (
    <div className="acct-section">
      <div className="acct-greet">
        <p className="eyebrow">{accountTx('Mes informations', 'My details')}</p>
        <h1>{accountTx('CoordonnÃ©es & prÃ©fÃ©rences.', 'Contact details & preferences.')}</h1>
        <p className="lede">{accountTx("Pour qu'on puisse vous joindre, et qu'on n'oublie rien.", 'So I can contact you and keep track of the important details.')}</p>
      </div>

      <div className="profile-grid">
        <div className="profile-block">
          <h4>{accountTx('IdentitÃ©', 'Identity')}</h4>
          <div className="kv-row"><span>{accountTx('PrÃ©nom', 'First name')}</span><span>{ACCOUNT_USER.firstName}</span></div>
          <div className="kv-row"><span>{accountTx('Nom', 'Last name')}</span><span>{ACCOUNT_USER.lastName}</span></div>
          <div className="kv-row"><span>{accountTx('NÂ° client', 'Customer no.')}</span><span className="mono">{clientReference}</span></div>
          <div className="kv-row"><span>{accountTx('Membre depuis', 'Member since')}</span><span>{ACCOUNT_USER.member_since || '-'}</span></div>
        </div>
        <div className="profile-block">
          <h4>{accountTx('Contact', 'Contact')}</h4>
          <div className="kv-row"><span>Email</span><span>{ACCOUNT_USER.email}</span></div>
          <div className="kv-row"><span>{accountTx('TÃ©lÃ©phone', 'Phone')}</span><span>{ACCOUNT_USER.phone || '-'}</span></div>
          <div className="kv-row" style={{alignItems:'flex-start'}}>
            <span>{accountTx('Adresse', 'Address')}</span>
            <span style={{whiteSpace:'pre-line', textAlign:'right'}}>{ACCOUNT_USER.address || '-'}</span>
          </div>
          <button className="btn ghost" style={{marginTop:18, padding:'10px 16px', fontSize:13}}>{accountTx('Modifier mes coordonnÃ©es', 'Edit my contact details')}</button>
        </div>
        <div className="profile-block">
          <h4>{accountTx('PrÃ©fÃ©rences', 'Preferences')}</h4>
          <label className="switch-row">
            <span>{accountTx('Recevoir la newsletter (rare)', 'Receive the newsletter (rarely)')}</span>
            <input type="checkbox" defaultChecked/>
          </label>
          <label className="switch-row">
            <span>{accountTx('Notifications par email pour mes rÃ©parations', 'Email notifications for my repairs')}</span>
            <input type="checkbox" defaultChecked/>
          </label>
          <label className="switch-row">
            <span>{accountTx('SMS pour le retour du matÃ©riel', 'SMS for equipment return')}</span>
            <input type="checkbox"/>
          </label>
        </div>
        <div className="profile-block danger">
          <h4>{accountTx('Compte', 'Account')}</h4>
          <a href={ACCOUNT_USER.lostPasswordUrl || '/wp-login.php?action=lostpassword'} className="btn ghost" style={{padding:'10px 16px', fontSize:13, marginRight:8}}>{accountTx('Changer mot de passe', 'Change password')}</a>
          <a href={ACCOUNT_USER.logoutUrl || '/wp-login.php?action=logout'} className="btn ghost" style={{padding:'10px 16px', fontSize:13}}>{accountTx('Se dÃ©connecter', 'Log out')}</a>
          <p className="muted small" style={{marginTop:18, fontStyle:'italic'}}>
            {accountTx('Pour supprimer votre compte, Ã©crivez-nous Ã  atelier@hostophoto.fr.', 'To delete your account, write to atelier@hostophoto.fr.')}
          </p>
        </div>
      </div>
    </div>
  );
}

/* ---- Main page ---- */


function AccountNavIcon({ id }) {
  const sprites = {
    dashboard: [
      '00100',
      '01110',
      '11111',
      '10101',
      '10101',
    ],
    reparations: [
      '11110',
      '10010',
      '11110',
      '10100',
      '10111',
    ],
    commandes: [
      '01000',
      '11110',
      '11110',
      '01010',
      '01010',
    ],
    profil: [
      '01110',
      '01110',
      '00100',
      '01110',
      '11011',
    ],
  };
  const sprite = sprites[id] || sprites.profil;

  return (
    <span className={`pixel-nav-icon pixel-nav-icon-${id}`} aria-hidden="true">
      {sprite.flatMap((row, y) =>
        row.split('').map((cell, x) => (
          <span key={`${y}-${x}`} className={cell === '1' ? 'pixel-on' : 'pixel-off'} />
        ))
      )}
    </span>
  );
}

function AccountLoginScreen() {
  const loginPostUrl = ACCOUNT_USER.loginPostUrl || ACCOUNT_USER.loginUrl || '/wp-login.php';
  const redirectTo = ACCOUNT_USER.redirectTo || '/compte/';
  const registerUrl = ACCOUNT_USER.registerUrl || '/wp-login.php?action=register';
  const lostPasswordUrl = ACCOUNT_USER.lostPasswordUrl || '/wp-login.php?action=lostpassword';

  return (
    <section className="container" style={{paddingTop:72, paddingBottom:96}}>
      <div className="account-login-shell">
        <div className="account-login-copy">
          <p className="eyebrow">{accountTx('Espace client', 'Customer area')}</p>
          <h1>{accountTx('Connectez-vous pour suivre vos rÃ©parations et commandes.', 'Sign in to track your repairs and orders.')}</h1>
          <p className="lede">
            {accountTx("Retrouvez vos demandes de prise en charge, l'Ã©tat des cartons Ã  l'atelier et les prochaines Ã©tapes aprÃ¨s acceptation.", 'Find your intake requests, workshop file status and next steps after acceptance.')}
          </p>
          <a href={hpPath('devis')} className="linky">{accountTx('Faire une demande de prise en charge ->', 'Start an intake request ->')}</a>
        </div>

        <form className="account-login-form" method="post" action={loginPostUrl}>
          <h2>{accountTx('Connexion client', 'Customer login')}</h2>
          <label>
            <span>{accountTx('Adresse email ou identifiant', 'Email address or username')}</span>
            <input name="log" type="text" autoComplete="username" required />
          </label>
          <label>
            <span>{accountTx('Mot de passe', 'Password')}</span>
            <input name="pwd" type="password" autoComplete="current-password" required />
          </label>
          <label className="account-login-remember">
            <input name="rememberme" type="checkbox" value="forever" />
            <span>{accountTx('Rester connectÃ©', 'Stay signed in')}</span>
          </label>
          <input type="hidden" name="redirect_to" value={redirectTo} />
          <input type="hidden" name="testcookie" value="1" />
          <button type="submit" className="btn accent">{accountTx('Se connecter', 'Sign in')} <span className="arrow"/></button>
          <div className="account-login-links">
            <a href={lostPasswordUrl}>{accountTx('Mot de passe oubliÃ©', 'Forgot password')}</a>
            <a href={registerUrl}>{accountTx('CrÃ©er un compte', 'Create an account')}</a>
          </div>
        </form>
      </div>
    </section>
  );
}

function ComptePage() {
  if (!ACCOUNT_USER.isLoggedIn) return <AccountLoginScreen/>;

  const [tab, setTab] = React.useState('dashboard');
  const [portal, setPortal] = React.useState(null);
  const [portalLoading, setPortalLoading] = React.useState(false);
  const [portalError, setPortalError] = React.useState('');
  const workshopCartons = getWorkshopCartons(portal);
  const activeWorkshopCartons = workshopCartons.filter(isOpenCarton);

  const loadPortal = React.useCallback(() => {
    const api = window.HOSTOPHOTO_QUOTE_API || {};
    if (!api.isLoggedIn || !api.endpoint) return Promise.resolve();

    setPortalLoading(true);
    return fetchPortalJson('/my-workshop-status')
      .then(payload => {
        setPortal(payload);
        setPortalError(payload?.live_status === 'unavailable'
          ? (payload.message || accountTx('Le statut atelier est indisponible pour le moment.', 'Workshop status is unavailable for now.'))
          : '');
      })
      .catch(error => setPortalError(error.message || accountTx('Impossible de charger le statut atelier.', 'Unable to load workshop status.')))
      .finally(() => setPortalLoading(false));
  }, []);

  React.useEffect(() => {
    loadPortal();
  }, [loadPortal]);

  React.useEffect(() => {
    const refresh = () => loadPortal();
    window.addEventListener('hostophoto:portal-refresh', refresh);
    return () => window.removeEventListener('hostophoto:portal-refresh', refresh);
  }, [loadPortal]);

  const tabs = [
    { id: 'dashboard', label: accountTx('Tableau de bord', 'Dashboard'), n: null },
    { id: 'reparations', label: accountTx('Demandes & rÃ©parations', 'Requests & repairs'), n: portal ? activeWorkshopCartons.length : 0 },
    { id: 'commandes', label: accountTx('Mes commandes', 'My orders'), n: null },
    { id: 'profil', label: accountTx('Mes informations', 'My details'), n: null },
  ];

  return (
    <section className="container" style={{paddingTop:48, paddingBottom:80}}>
      <div className="acct-shell">
        <aside className="acct-side">
          <div className="acct-id-card">
            <div className="acct-avatar">
              <span>{getAccountInitials()}</span>
            </div>
            <div>
              <p className="eyebrow" style={{marginBottom:4}}>{accountTx('Espace client', 'Customer area')}</p>
              <h3 style={{fontSize:'1.25rem'}}>{getAccountName()}</h3>
              <p className="mono small muted" style={{marginTop:4}}>{getClientReference(portal)}</p>
            </div>
          </div>

          <nav className="acct-nav">
            {tabs.map(t => (
              <button key={t.id}
                      className={`acct-nav-item ${tab === t.id ? 'active' : ''}`}
                      onClick={() => setTab(t.id)}>
                <span className="acct-nav-label">
                  <span className="acct-nav-icon"><AccountNavIcon id={t.id}/></span>
                  <span>{t.label}</span>
                </span>
                {t.n != null && t.n > 0 && <span className="badge">{t.n}</span>}
              </button>
            ))}
          </nav>

        </aside>

        <div className="acct-main">
          {tab === 'dashboard' && <DashboardOverview onNav={setTab} portal={portal} portalLoading={portalLoading} portalError={portalError}/>}
          {tab === 'reparations' && <RepairsSection portal={portal} portalLoading={portalLoading} portalError={portalError}/>}
          {tab === 'commandes' && <OrdersSection/>}
          {tab === 'profil' && <ProfileSection portal={portal}/>}
        </div>
      </div>
    </section>
  );
}

function AccountRepairsEmbed() {
  const [portal, setPortal] = React.useState(null);
  const [portalLoading, setPortalLoading] = React.useState(false);
  const [portalError, setPortalError] = React.useState('');

  const loadPortal = React.useCallback(() => {
    const api = window.HOSTOPHOTO_QUOTE_API || {};
    if (!api.isLoggedIn || !api.endpoint) return Promise.resolve();

    setPortalLoading(true);
    return fetchPortalJson('/my-workshop-status')
      .then(payload => {
        setPortal(payload);
        setPortalError(payload?.live_status === 'unavailable'
          ? (payload.message || accountTx('Le statut atelier est indisponible pour le moment.', 'Workshop status is unavailable for now.'))
          : '');
      })
      .catch(error => setPortalError(error.message || accountTx('Impossible de charger le statut atelier.', 'Unable to load workshop status.')))
      .finally(() => setPortalLoading(false));
  }, []);

  React.useEffect(() => {
    loadPortal();
  }, [loadPortal]);

  React.useEffect(() => {
    const refresh = () => loadPortal();
    window.addEventListener('hostophoto:portal-refresh', refresh);
    return () => window.removeEventListener('hostophoto:portal-refresh', refresh);
  }, [loadPortal]);

  return <RepairsSection portal={portal} portalLoading={portalLoading} portalError={portalError}/>;
}

function mountAccountRepairsEmbed() {
  const root = document.getElementById('hostophoto-account-repairs-root');
  if (!root || !window.ReactDOM) return;
  ReactDOM.createRoot(root).render(<AccountRepairsEmbed/>);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountAccountRepairsEmbed, { once: true });
} else {
  mountAccountRepairsEmbed();
}

Object.assign(window, { ComptePage, AccountRepairsEmbed });



/* src/app.jsx */
﻿const TWEAK_DEFAULTS = {
  "accent": "#e00818",
  "accentDeep": "#a00612",
  "fontPair": 2,
  "fontDisplay": "\"Fraunces\", Georgia, serif",
  "fontBody": "\"JetBrains Mono\", monospace",
  "heroVariant": 0,
  "paperMode": 2
};

const ROUTE_PREFIXES = ['devis', 'quote', 'services', 'faq', 'tarifs', 'blog', 'contact', 'compte', 'account', 'article', 'en'];

function cleanRouteFromLocation() {
  const hash = window.location.hash || '';
  if (hash.startsWith('#/')) {
    const cleanPath = hash.replace(/^#/, '') || '/';
    window.history.replaceState({}, '', cleanPath);
    return cleanPath;
  }

  return `${window.location.pathname}${window.location.search}`;
}

function useRouteLocation() {
  const [locationKey, setLocationKey] = React.useState(cleanRouteFromLocation());

  React.useEffect(() => {
    const update = () => {
      setLocationKey(cleanRouteFromLocation());
    };

    window.addEventListener('popstate', update);
    window.addEventListener('hashchange', update);

    return () => {
      window.removeEventListener('popstate', update);
      window.removeEventListener('hashchange', update);
    };
  }, []);

  return locationKey;
}

function App() {
  const locationKey = useRouteLocation();
  const wc = window.HOSTOPHOTO_WOOCOMMERCE || {};

  React.useEffect(() => { applyTweaks(TWEAK_DEFAULTS); }, []);
  React.useEffect(() => {
    window.setTimeout(() => {
      if (typeof hpTranslatePageText === 'function') hpTranslatePageText();
    }, 0);
  }, [locationKey]);

  const route = React.useMemo(() => {
    return hpRouteInfoFromPath(window.location.pathname);
  }, [locationKey]);

  const current = route.page === 'article' ? 'blog' : route.page;

  return (
    <div data-screen-label={current}>
      <Topbar/>
      <Header current={current} cart={0} cartUrl={wc.cartUrl || '/panier/'}/>
      <main id="main-content" tabIndex={-1}>
        {route.page === 'home' && <HomePage heroVariant={TWEAK_DEFAULTS.heroVariant}/>}
        {route.page === 'blog' && <BlogIndex/>}
        {route.page === 'article' && <ArticlePage slug={route.slug}/>}
        {route.page === 'services' && <ServicesPage/>}
        {route.page === 'faq' && <TarifsPage/>}
        {route.page === 'devis' && <DevisPage/>}
        {route.page === 'compte' && <ComptePage/>}
        {route.page === 'contact' && <ContactPage/>}
      </main>
      <Footer/>
    </div>
  );
}

const hostophotoRoot = document.getElementById('root');
if (hostophotoRoot) {
  ReactDOM.createRoot(hostophotoRoot).render(<App/>);
}


